import labourPlanningService from "../src/services/labourPalnningService";
import { mapState, mapActions } from "vuex";
import axios from "axios";
import moment from "moment";
import { EventBus } from "../src/eventBus";
import exportFromJSON from "export-from-json";
import labourPalnningService from "../src/services/labourPalnningService";
export default {
	data() {
		return {
			head_office_id: '',
			is_plan_by: 'duration',
			time_frame_list:[
				{
					id: 'pre_opening',
					name: 'Pre Opening'
				},
				{
					id: 'operation_hours',
					name: 'Operation Hours'
				},
				{
					id: 'post_closing',
					name: 'Post Closing'
				}
			]
		}
	},
	computed: {
		...mapState("CommonStore", [
			"storeDetailsProcessing", 
			"storeProcessingCompleted"
		]),
		...mapState("SettingStore", [
			"locations",
			"selectedCountry",
			"selectedRegion",
			"selectedSubRegion",
			"selectedOutlet",
			"storeSections",
			"showSectionModal",
			"sectionData",
			"dailyActivities",
			"coverageActivities",
			"functions",
			"departments",
			"designations",
			"outlets",
			"showCoverageActivity",
			"coverageActivityDetails",
			"planning",
			"planningType",
			"selectedSections",
			"addTime_list",
			"averageTimePerCategory",
			"category_list",
			"numTeancListData",
			"transactionActivitiesList",
			"orderTypeList",
			"department_list",
			"selectedFunctions",
			"is_admin",
			"preparation_activity",
			"add_time",
			"planningLevel",
			"departmentActivities",
			"selected_categories",
			"selectPlanningLevelDepartment",
			"selectedSubCategories",
			"subcategoryList",
			"change_keys",
			"overallAverage",
			"subCategoryActivityList",
			"selectedDepartmentList",
			"transactionThresholdRange",
			"orderTypeList",
			"showNonCoverageActivityPopup",
			"selectedFrequency",
			"selectedPlanBy",
			"editSectionActivity",
			"selectedOrderType",
			"hoursArr",
			"minsAndSecArr",
			"quantityArr",
			"store_details_id",
			"planType",
			"selected_function_list",
			"filter_functions",
			"filter_functionsList",
			"non_coverage_activities",
			"sectionFunctionData",
			"searchedSection",
			"searchedCoverageActivity",
			"hideShowNonCoverageActivity",
			"selectedFilterSections",
			"selectedFilterStations",
			"days",
			"selectedFilterDays",
			"testNonCoverageActivityData",
			"testCoverageLabels",
			"companyLevelSections",
			"hideShowStationAddEditPopup",
			"stationDetails",
			"hideShowBulkEditNonCoveragePopup",
			"bulkSavePerson",
			"searchedNonCoverageStation",
			"filterActivityData",
			"sectionFunctionData",
			"rawDailyActivities",
			"frequency_hourly_value_list",
			"editSelectNonCoverageActivity",
			"answeredActivityData",
			"storeSectionDetails",
			"showStoreSectionModal",
			"nonCoverageActivityDetails",
			"timeSlots",
			"daysList",
			"dailyActivityView",
			"updatedFormatCoverageActivities",
			"updatedEditCoverageActivity",
			"hideShowNewCoverageActivity",
			"coverageTableLoading",
			"selectedStoreSettingSection",
			"selectedStoreSettingStation",
			"groupedStoreSettingCoverageActivities",
			"groupedStoreSettingNonCoverageActivities",
			"hideShowCoverageGroupedCoverageActivityModal",
			"storeSettingsNonCoverageActivityIds",
			"showMultipleFilteredNonCoverageActivities",
			"filteredNonCoverageActivities",
			"workforceOptions",
			"groupedDailyActivities",
			"activityTypeList",
			"activityDialogVisible",
			"activityName",
			"selectedActivity",
			"allStoreType",
			"dineIn",
			"isRestroom",
			"driveThrough",
			"isDelivery",
			"isDailyActivitesLoading",
			"isAddActivityInProgress",
			// Store guidelines
			"staffDetails",
			"showStoreDetailsSaveConfirmation",
			"storeDetailsSaveChoice",
			"nonCoverageActivityHourlyView",
			"nonCoverageActivityHourlyViewSummary",
			"nonCoverageDailyViewLabels",
			"nonCoverageDailyViewLabelsFor30Min",
			"selectedHourlyActivitiesIds",
			"selectedHourlyViewDays",
			"selectedHourlyViewStartTime",
			"selectedHourlyViewEndTime",
			"selectedHourlyViewNumberOfPeople",
			"selectedHourlyFilterActivities",
			"selectedHourlyDays",
		]),
		...mapState("LabourPlanning", ["storeName", "sectionDetailsData", "sectionTableLoadingStore"]),
		nonCoverageDailyViewLabelsComputed(){
			let labels = [];
			let data = this.non_coverage_activity_hourly_view.length ? this.non_coverage_activity_hourly_view[6].timewise_sum : '';
			if(data){
				for (const key in data) {
					if (Object.hasOwnProperty.call(data, key)) {
						let elm = data[key];
						if(key.split('-')[1]== '00'){
							labels.push({label: key, value: moment(key, 'HH-mm').format('hh A')});
						}
					}
				}
			}
            return labels;
        },
		timeSlotFoeBulkEdit(){
			let labels = [];
			labels = this.nonCoverageDailyViewLabels;
				if(this.staffDetails.forecast_and_schedule_time_interval === "00:30:00") {
					labels = this.nonCoverageDailyViewLabelsFor30Min;
				}
			return labels;
		},
		filtered_activity_type_list() {
			let all_activities = [...this.activityTypeList];
			let daily_activity = [...this.dailyActivityList];
			all_activities.map((e)=>{
				const da = daily_activity.find((a)=> a.activity_id === e.id);
				if(da){
					e.plan_by = da.plan_by;
				}
			});
			// if(this.is_plan_by){
			// 	all_activities = all_activities.filter((f)=> f.plan_by === this.is_plan_by);
			// }
			return all_activities;
		},
		getActivityType(activity_type_id) {
			if(this.activity_type_list && this.activity_type_list.length) {
				const checkData = this.activity_type_list.find(el => el.id == activity_type_id);
				if(checkData && checkData.name) {
					console.log(checkData, 'checkData')
					return checkData.name;
				} else {
					return '-';
				}
			} else {
				return '-';
			}
		},
		generatedTimeSlot(){
			return this.generateTimeSlots();
		},
		headOfficeId(){
			return this.head_office_id;
		},
		show_multiple_filtered_non_coverage_activities: {
			get() {
				return this.showMultipleFilteredNonCoverageActivities;
			},
			set(val) {
				this.$store.commit("SettingStore/updateShowMultipleFilteredNonCoverageActivities", val);
			}
		},
		filtered_non_coverage_activities: {
			get() {
				return this.filteredNonCoverageActivities;
			},
			set(val) {
				this.$store.commit("SettingStore/updateFilteredNonCoverageActivities", val);
			}
		},
		locationData: {
			get() {
				return this.locations;
			},
			set(val) {
				this.$store.commit("SettingStore/updateLocations", val);
			},
		},
		country: {
			get() {
				return this.selectedCountry;
			},
			set(val) {
				this.$store.commit("SettingStore/updateCountry", val);
			},
		},
		region: {
			get() {
				return this.selectedRegion;
			},
			set(val) {
				this.$store.commit("SettingStore/updateRegion", val);
			},
		},
		subregion: {
			get() {
				return this.selectedSubRegion;
			},
			set(val) {
				this.$store.commit("SettingStore/updateSubRegion", val);
			},
		},
		outlet: {
			get() {
				return this.selectedOutlet;
			},
			set(val) {
				this.$store.commit("SettingStore/updateOutlet", val);
			},
		},
		sections: {
			get() {
				return this.storeSections;
			},
			set(val) {
				this.$store.commit("SettingStore/updateSections", val);
			},
		},
		showSections: {
			get() {
				return this.showSectionModal;
			},
			set(val) {
				this.$store.commit("SettingStore/updateShowSection", val);
			},
		},
		sectionDetails: {
			get() {
				return this.sectionData;
			},
			set(val) {
				this.$store.commit("SettingStore/updateSectionData", val);
			},
		},
		dailyActivityList: {
			get() {
				let result = [...this.dailyActivities];
				if(this.searched_non_coverage_station) {
					result = result.filter((el) => el.function_name.toLowerCase().includes(this.searched_non_coverage_station.toLowerCase()));
				}
				return result;
			},
			set(val) {
				this.$store.commit("SettingStore/updateDailyActivities", val);
			},
		},
		coverageActivityList: {
			get() {
				let results = [...this.coverageActivities];
				if (this.search_coverage_activity) {
					let all_stations = [...this.storeFunctions];
					let filtered_functions = all_stations.filter((el) => el.function.toLowerCase().includes(this.search_coverage_activity.toLowerCase())).map(el => el.id);
					results = results.filter((el) => filtered_functions.includes(el.function_id));
				}
				return results;
			},
			set(val) {
				this.$store.commit("SettingStore/updateCoverageActivites", val);
			},
		},
		storeFunctions: {
			get() {
				return this.functions;
			},
			set(val) {
				this.$store.commit("SettingStore/updateFunctions", val);
			},
		},
		storeDepartments: {
			get() {
				return this.departments;
			},
			set(val) {
				this.$store.commit("SettingStore/updateDepartments", val);
			},
		},
		storeDesignations: {
			get() {
				return this.designations;
			},
			set(val) {
				this.$store.commit("SettingStore/updateDesignations", val);
			},
		},
		outletLists: {
			get() {
				return this.outlets;
			},
			set(val) {
				this.$store.commit("SettingStore/updateOutlets", val);
			},
		},
		showCoverageActivityModal: {
			get() {
				return this.showCoverageActivity;
			},
			set(val) {
				this.$store.commit("SettingStore/updateShowCoverageActivity", val);
			},
		},
		coverageActivityDetail: {
			get() {
				return this.coverageActivityDetails;
			},
			set(val) {
				this.$store.commit("SettingStore/updateCoverageActivityDetails", val);
			},
		},
		selected_functions: {
			get() {
				return this.selectedFunctions;
			},
			set(val) {
				this.$store.commit("SettingStore/updateSelectedFunction", val);
			},
		},
		planning_type: {
			get() {
				return this.planningType;
			},
			set(val) {
				this.$store.commit("SettingStore/updatePlanningType", val);
			},
		},
		selected_section: {
			get() {
				return this.selectedSections;
			},
			set(val) {
				this.$store.commit("SettingStore/updateSelectedSection", val);
			},
		},
		avgTimePerCategory: {
			get() {
				return this.averageTimePerCategory;
			},
			set(val) {
				this.$store.commit("SettingStore/updateAverageTimePerCategory", val);
			},
		},
		categoryList: {
			get() {
				return this.category_list;
			},
			set(val) {
				this.$store.commit("SettingStore/updateCategoryList", val);
			},
		},
		numTeancList: {
			get() {
				return this.numTeancListData;
			},
			set(val) {
				this.$store.commit("SettingStore/updateNumTeancListData", val);
			},
		},
		transactionActivities: {
			get() {
				return this.transactionActivitiesList;
			},
			set(val) {
				this.$store.commit("SettingStore/updateTransactionActivitiesList", val);
			},
		},
		order_type_list: {
			get() {
				return this.orderTypeList;
			},
			set(val) {
				this.$store.commit("SettingStore/updateOrderTypeList", val);
			},
		},
		departmentList: {
			get() {
				return this.department_list;
			},
			set(val) {
				this.$store.commit("SettingStore/updateDepartmentList", val);
			},
		},
		isAdmin: {
			get() {
				return this.is_admin;
			},
			set(val) {
				this.$store.commit("SettingStore/updateIsAdmin", val);
			},
		},
		isDemoID(){
			const enabled_cid = ['eff690f9-58ca-4dc0-881b-9b1feb97cb49', '725cc6e0-658b-48d9-9039-794a23f18d99'];
			return enabled_cid.includes(localStorage.getItem('company_id'));
		},
		hasAdminAccess(){
			let access = (this.isAdmin === 'admin' 
			|| this.isAdmin === 'super' 
			|| this.isAdmin === 'region'
			|| this.isAdmin === 'sub_region');

			// if(this.isDemoID) {
			// 	access = (this.isAdmin === 'admin' 
			// || this.isAdmin === 'super' 
			// || this.isAdmin === 'region'
			// || this.isAdmin === 'sub_region' ||
			// this.isAdmin === 'outlet')
			// }
			return access;
		},
		postOnboardingAccess(){
			const isClient = JSON.parse(localStorage.getItem('check_company'));

			let access =  (this.isAdmin === 'admin' 
			|| this.isAdmin === 'super' 
			|| this.isAdmin === 'region'
			|| this.isAdmin === 'sub_region'
			|| this.isAdmin === 'outlet'
			) && (
				isClient.is_sb_malaysia ||
				isClient.is_kfc ||
				isClient.is_bt ||
				isClient.is_gf
			);

			// if(this.isDemoID) {
			// 	access = (this.isAdmin === 'admin' 
			// 	|| this.isAdmin === 'super' 
			// 	|| this.isAdmin === 'region'
			// 	|| this.isAdmin === 'sub_region' ||
			// 	this.isAdmin === 'outlet')
			// }
			return access;
		},
		adminAccess(){
			return this.isAdmin === 'admin';
		},
		regionAccess(){
			const checkCompany = JSON.parse(localStorage.getItem('check_company'));
			return this.isAdmin === 'region' && checkCompany.is_mcd;
		},
		sub_regionAccess(){
			const checkCompany = JSON.parse(localStorage.getItem('check_company'));
			return this.isAdmin === 'sub_region' && checkCompany.is_mcd;
		},
		outletAccess(){
			const checkCompany = JSON.parse(localStorage.getItem('check_company'));
			return this.isAdmin === 'outlet' && checkCompany.is_mcd;
		},
		preparationActivity: {
			get() {
				return this.preparation_activity;
			},
			set(val) {
				this.$store.commit("SettingStore/updatePreparationActivity", val);
			},
		},
		addTime: {
			get() {
				return this.add_time;
			},
			set(val) {
				this.$store.commit("SettingStore/updateAddTime", val);
			},
		},
		order_type: {
			get() {
				return this.selectedOrderType;
			},
			set(val) {
				this.$store.commit("SettingStore/updateSelectedOrderType", val);
			},
		},
		planning_level: {
			get() {
				return this.planningLevel;
			},
			set(val) {
				this.$store.commit("SettingStore/updatePlanningLevel", val);
			},
		},
		department_activities: {
			get() {
				return this.departmentActivities;
			},
			set(val) {
				this.$store.commit("SettingStore/updateDepartmentActivities", val);
			},
		},
		selectedCategories: {
			get() {
				return this.selected_categories;
			},
			set(val) {
				this.$store.commit("SettingStore/updateSelectedCategories", val);
			},
		},
		select_planning_level_department: {
			get() {
				return this.selectPlanningLevelDepartment;
			},
			set(val) {
				this.$store.commit(
					"SettingStore/updateSelectPlanningLevelDepartment",
					val
				);
			},
		},
		selected_sub_categories: {
			get() {
				return this.selectedSubCategories;
			},
			set(val) {
				this.$store.commit("SettingStore/updateSelectedSubCategories", val);
			},
		},
		subcategory_list: {
			get() {
				return this.subcategoryList;
			},
			set(val) {
				this.$store.commit("SettingStore/updateSubcategoryList", val);
			},
		},
		changeKeys: {
			get() {
				return this.change_keys;
			},
			set(val) {
				this.$store.commit("SettingStore/updateChangeKeys", val);
			},
		},
		overall_average: {
			get() {
				return this.overallAverage;
			},
			set(val) {
				this.$store.commit("SettingStore/updateOverallAverage", val);
			},
		},
		sub_category_activity_list: {
			get() {
				return this.subCategoryActivityList;
			},
			set(val) {
				this.$store.commit("SettingStore/updateSubCategoryActivityList", val);
			},
		},
		selected_department_list: {
			get() {
				return this.selectedDepartmentList;
			},
			set(val) {
				this.$store.commit("SettingStore/updateSelectedDepartmentList", val);
			},
		},
		transaction_threshold_range: {
			get() {
				return this.transactionThresholdRange;
			},
			set(val) {
				this.$store.commit("SettingStore/updateTransactionThresholdRange", val);
			},
		},
		showNonCoverageActivity: {
			get() {
				return this.showNonCoverageActivityPopup;
			},
			set(val) {
				this.$store.commit(
					"SettingStore/updateShowNonCoverageActivityPopup",
					val
				);
			},
		},
		selectedFrequencyVal: {
			get() {
				return this.selectedFrequency;
			},
			set(val) {
				this.$store.commit("SettingStore/updateSelectedFrequency", val);
			},
		},
		selectedPlanByVal: {
			get() {
				return this.selectedPlanBy;
			},
			set(val) {
				this.$store.commit("SettingStore/updateSelectedPlanBy", val);
			},
		},
		updateSectionActivity: {
			get() {
				return this.editSectionActivity;
			},
			set(val) {
				this.$store.commit("SettingStore/updateEditSectionActivity", val);
			}
		},
		quantityList: {
			get() {
				return this.quantityArr;
			},
			set(val) {
				this.$store.commit("SettingStore/updateQuantityArr", val);
			}
		},
		storeDetailsId: {
			get() {
				return this.store_details_id;
			},
			set(val) {
				this.$store.commit("SettingStore/updateStoreDetailsId", val);
			}
		},
		plan_type: {
			get() {
				return this.planType;
			},
			set(val) {
				this.$store.commit("SettingStore/updatePlanType", val);
			}
		},
		selectedFunctionList: {
			get() {
				return this.selected_function_list;
			},
			set(val) {
				this.$store.commit("SettingStore/updateSelectedFunctionList", val);
			}
		},
		filterFunctions: {
			get() {
				return this.filter_functions;
			},
			set(val) {
				this.$store.commit("SettingStore/updateFilterFunctions", val);
			}
		},
		filterFunctionsList: {
			get() {
				return this.filter_functionsList;
			},
			set(val) {
				this.$store.commit("SettingStore/updateFilterFunctionsList", val);
			}
		},
		nonCoverageActivitiesList: {
			get() {
				return this.non_coverage_activities;
			},
			set(val) {
				this.$store.commit("SettingStore/updateNonCoverageActivities", val);
			}
		},
		section_function_data: {
			get() {
				return this.sectionFunctionData;
			},
			set(val) {
				this.$store.commit("SettingStore/updateSectionFunctionData", val);
			}
		},
		generalSettingsStore: {
			get() {
				return this.storeName;
			},
			set(val) {
				this.$store.commit("LabourPlanning/SET_STORE_NAME", val);
			}
		},
		search_section: {
			get() {
				return this.searchedSection;
			},
			set(val) {
				this.$store.commit("SettingStore/updateSearchedSection", val);
			}
		},
		search_coverage_activity: {
			get() {
				return this.searchedCoverageActivity;
			},
			set(val) {
				this.$store.commit("SettingStore/updateSearchedCoverageActivity", val);
			}
		},
		hide_show_non_coverage_activity: {
			get() {
				return this.hideShowNonCoverageActivity;
			},
			set(val) {
				this.$store.commit("SettingStore/updateHideShowNonCoverageActivity", val);
			}
		},
		selected_filter_sections: {
			get() {
				return this.selectedFilterSections;
			},
			set(val) {
				this.$store.commit("SettingStore/updateSelectedFilterSections", val);
			}
		},
		selected_filter_stations: {
			get() {
				return this.selectedFilterStations;
			},
			set(val) {
				this.$store.commit("SettingStore/updateSelectedFilterStations", val);
			}
		},
		selected_filter_days: {
			get() {
				return this.selectedFilterDays;
			},
			set(val) {
				this.$store.commit("SettingStore/updateSelectedFilterDays", val);
			}
		},
		company_level_sections: {
			get() {
				return this.companyLevelSections;
			},
			set(val) {
				this.$store.commit("SettingStore/updateCompanyLevelSections", val);
			}
		},
		filtered_company_level_sections() {
			let result = [...this.company_level_sections];
			if(this.search_section) {
				result = result.filter((el) => el.name.toLowerCase().includes(this.search_section.toLowerCase()));
			}
			return result;
		},
		hide_show_station_add_edit_popup: {
			get() {
				return this.hideShowStationAddEditPopup;
			},
			set(val) {
				this.$store.commit("SettingStore/updateHideShowStationAddEditPopup", val);
			}
		},
		station_details: {
			get() {
				return this.stationDetails;
			},
			set(val) {
				this.$store.commit("SettingStore/updateStationDetails", val);
			}
		},
		coverageActivitiesDailyViewData: {
			get() {
				return this.testNonCoverageActivityData;
			},
			set(val) {
				this.$store.commit("SettingStore/updateTestNonCoverageActivityData", val);
			}
		},
		hide_show_bulk_edit_non_coverage_popup: {
			get() {
				return this.hideShowBulkEditNonCoveragePopup;
			},
			set(val) {
				this.$store.commit("SettingStore/updateHideShowBulkEditNonCoveragePopup", val);
			}
		},
		bulk_save_person: {
			get() {
				return this.bulkSavePerson;
			},
			set(val) {
				this.$store.commit("SettingStore/updateBulkSavePerson", val);
			}
		},
		searched_non_coverage_station: {
			get() {
				return this.searchedNonCoverageStation;
			},
			set(val) {
				this.$store.commit("SettingStore/updateSearchedNonCoverageStation", val);
			}
		},
		filterActivity: {
			get() {
				return this.filterActivityData;
			},
			set(val) {
				this.$store.commit("SettingStore/updateFilterActivity", val);
			}
		},
		raw_daily_activities: {
			get() {
				let result = [...this.rawDailyActivities];
				if(this.searched_non_coverage_station) {
					let function_names = this.functions.filter(el => el.name.toLowerCase().includes(this.searched_non_coverage_station.toLowerCase())).map(el => el.id);
					result = result.filter((el) => function_names.includes(el.function));
				}
				return result;
			},
			set(val) {
				this.$store.commit("SettingStore/updateRawDailyActivities", val);
			}
		},
		edit_select_non_coverage_activity: {
			get() {
				return this.editSelectNonCoverageActivity;
			},
			set(val) {
				this.$store.commit("SettingStore/updateEditSelectNonCoverageActivity", val);
			}
		},
		answered_activity_data: {
			get() {
				return this.answeredActivityData;
			},
			set(val) {
				this.$store.commit("SettingStore/updateAnsweredActivityData", val);
			}
		},
		store_section_details: {
			get() {
				return this.storeSectionDetails;
			},
			set(val) {
				this.$store.commit("SettingStore/updateStoreSectionDetails", val);
			}
		},
		show_store_section_modal: {
			get() {
				return this.showStoreSectionModal;
			},
			set(val) {
				this.$store.commit("SettingStore/updateShowStoreSectionModal", val);
			}
		},
		groupedNonCoverageSections: {
			get() {
			  let result = [...this.dailyActivityList];

			  let response = result.reduce((groups, item) => {
				const group = (groups[item.store_section] || []);
				group.push(item);
				if(item.store_section) {
					groups[item.store_section] = group;
				}
				return groups;
			  }, {});

			  return response;
			},
			set(value) {
			  let result = [...value];
			  let response = [];
			  result.forEach(el => {
				response.push(el);
			  });
			  this.dailyActivityList = [...response];
			}
		},
		groupedCoverageSections: {
			get() {
			  let result = [...this.coverageActivityList];

			  let response = result.reduce((groups, item) => {
				const group = (groups[item.store_section] || []);
				group.push(item);
				if(item.store_section) {
					groups[item.store_section] = group;
				}
				return groups;
			  }, {});

			  return response;
			},
			set(value) {
			  let result = [...value];
			  let response = [];
			  result.forEach(el => {
				response.push(el);
			  });
			  this.coverageActivityList = [...response];
			}
		},
		non_coverage_activity_details: {
			get() {
				return this.nonCoverageActivityDetails;
			},
			set(val) {
				this.$store.commit("SettingStore/updateNonCoverageActivityDetails", val);
			}
		},
		daily_activity_view: {
			get() {
				return this.dailyActivityView;
			},
			set(val) {
				this.$store.commit("SettingStore/updateDailyActivityView", val);
			}
		},
		// formatted_daily_view_non_coverage_activities: {
		// 	get() {
		// 		let non_coverage_activities = [...this.dailyActivityList];
		// 		let result = [];

		// 		if(non_coverage_activities.actions && non_coverage_activities.actions.length) {
		// 			non_coverage_activities.forEach((el) => {
		// 				let obj = {
		// 					activity_id: el.activity_id,
		// 				};

		// 				let timeUnits = [];
		// 				if(el.selected_time_units && el.selected_time_units.length) {
		// 					for(let i = 0; i < el.selected_time_units.length; i++) {
		// 						let start_time = el.selected_time_units[i].start_time;
		// 						let end_time = el.selected_time_units[i].end_time;
		// 						let startHrs = start_time.split(':')[0];
		// 						let endHrs = end_time.split(':')[0];
		// 						// let tempEndHrs = endHrs;
		// 						let newTempHrs = Number(endHrs);
		// 						for(let j = 1; j > 0; j++) {
		// 							let tempEndHrs = Number(startHrs) + j;
		// 							if(tempEndHrs == 24) {
		// 								tempEndHrs = 0;
		// 							}
		// 							let actualEndHrs = Number(endHrs);
		// 							if(tempEndHrs == actualEndHrs) {
		// 								timeUnits.push({

		// 								})
		// 								break;
		// 							}
		// 						}

		// 					}
		// 				}
		// 			})
		// 		}
		// 	},
		// 	set(val) {

		// 	}
		// },
		updated_format_coverage_activities: {
			get() {
				return this.updatedFormatCoverageActivities;
			},
			set(val) {
				this.$store.commit("SettingStore/updateUpdatedFormatCoverageActivities", val);
			}
		},
		row_wise_company_coverage_activities() {
			let result = [...this.updated_format_coverage_activities];
			let output = [];

			for(let i = 0; i < result.length; i++) {
				for(let j = 0; j < result[i].section_setup.length; j++) {
					let obj = {
						section_name: result[i].section_name,
						main_index_value: j,
						...result[i].section_setup[j],
					};
					output.push(obj);
				}
			}

			return output;
		},
		row_wise_company_non_coverage_activities() {
			let result = this.mappedSectionsAndStations.filter(el => el.setups_for_section.filter(e => e.non_coverage_hours_defined).length);
			let output = [];
			for(let i = 0; i < result.length; i++) {
				for(let j = 0; j < result[i].setups_for_section.length; j++) {
					if(result[i].setups_for_section[j].non_coverage_hours_defined) {
						let obj = {};
						obj = {section_index: i, station_index: j, ...obj, ...result[i]};
						this.$delete(obj, 'setups_for_section');
						obj = {...obj, ...result[i].setups_for_section[j]};
						if(this.grouped_daily_activities && this.grouped_daily_activities[result[i].id] && this.grouped_daily_activities[result[i].id][result[i].setups_for_section[j].function]) {
							obj.non_coverage_activities = this.grouped_daily_activities[result[i].id][result[i].setups_for_section[j].function];
						} else {
							obj.non_coverage_activities = [];
						}
						output.push(obj);
					}
				}
			}
			return output;
		},
		updated_edit_coverage_activity: {
			get() {
				return this.updatedEditCoverageActivity;
			},
			set(val) {
				this.$store.commit("SettingStore/updateUpdatedEditCoverageActivity", val);
			}
		},
		hide_show_new_coverage_activity: {
			get() {
				return this.hideShowNewCoverageActivity;
			},
			set(val) {
				this.$store.commit("SettingStore/updateHideShowNewCoverageActivity", val);
			}
		},
		// Store guidelines
		staff_details: {
			get() {
				return this.staffDetails;
			},
			set(value) {
				this.$store.commit("SettingStore/updateStaffDetails", value);
			}
		},
		coverage_table_loading: {
			get() {
				return this.coverageTableLoading;
			},
			set(value) {
				this.$store.commit("SettingStore/updateCoverageTableLoading", value);
			}
		},
		mappedSectionsAndStations: {
			get() {
				let result = [...this.storeSections];
				result = result.map((el) => ({
					...el,
					editable: false,
					mapped_functions: el.setups_for_section.map((element) => element.function)
				}))
				if(this.searched_non_coverage_station) {
					result = result.filter((el) => el.name.toLowerCase().includes(this.searched_non_coverage_station.toLowerCase()));
				}
				return result;
			},
			set(val) {
				let data = [...val];
				for(let i = 0; i < data.length; i++) {
					let functionData = [...data[i].mapped_functions];
					let allExistingIds = data[i].setups_for_section.map(el => el.function);
					let existingSetups = data[i].setups_for_section.filter((el) => functionData.includes(el.function));
					let deletedSetups = data[i].setups_for_section.filter((el) => !functionData.includes(el.function)).map(el => el.function);
					let updatedSetupIds = [...functionData, ...existingSetups.map(el => el.function)];
					updatedSetupIds = updatedSetupIds.filter((item, index) => updatedSetupIds.indexOf(item) === index);
					let newIds = updatedSetupIds.filter(el => !allExistingIds.includes(el));
					let functionDataList = [];
					if(newIds.length) {
						for(let j = 0; j < newIds.length; j++) {
							let findData = this.storeFunctions.find(el => el.id == newIds[j]);
							if(findData) {
								functionDataList.push({
									// id: null,
									function: findData.id,
									function_name: findData.function,
									store_section: data[i].id,
									store: this.outlet,
									enabled: false,
									coverage_hours_defined: false,
									non_coverage_hours_defined: true,
								})
							}
						}
					}
					data[i].setups_for_section = [...data[i].setups_for_section.filter(el => !deletedSetups.includes(el.function)), ...functionDataList];
				}
				data.forEach(el => this.$delete(el, 'mapped_functions'));
				this.$store.commit("SettingStore/updateSections", data);
			}
		},
		selected_store_setting_section: {
			get() {
				return this.selectedStoreSettingSection;
			},
			set(val) {
				this.$store.commit("SettingStore/updateSelectedStoreSettingSection", val);
			}
		},
		selected_store_setting_station: {
			get() {
				return this.selectedStoreSettingStation;
			},
			set(val) {
				this.$store.commit("SettingStore/updateSelectedStoreSettingStation", val);
			}
		},
		grouped_store_setting_coverage_activities: {
			get() {
				return this.groupedStoreSettingCoverageActivities;
			},
			set(val) {
				this.$store.commit("SettingStore/updateGroupedStoreSettingCoverageActivities", val);
			}
		},
		grouped_store_setting_non_coverage_activities: {
			get() {
				return this.groupedStoreSettingNonCoverageActivities;
			},
			set(val) {
				this.$store.commit("SettingStore/updateGroupedStoreSettingNonCoverageActivities", val);
			}
		},
		hide_show_coverage_grouped_coverage_activity_modal: {
			get() {
				return this.hideShowCoverageGroupedCoverageActivityModal;
			},
			set(val) {
				this.$store.commit("SettingStore/updateHideShowCoverageGroupedCoverageActivityModal", val);
			}
		},
		store_settings_non_coverage_activity_ids: {
			get() {
				return this.storeSettingsNonCoverageActivityIds;
			},
			set(val) {
				this.$store.commit("SettingStore/updateStoreSettingsNonCoverageActivityIds", val);
			}
		},
		isCompanySettingsPage() {
			if(this.$router.currentRoute.name == "Company") {
				return true;
			} else {
				return false;
			}
		},
		grouped_daily_activities: {
			get() {
				return this.groupedDailyActivities;
			},
			set(val) {
				this.$store.commit("SettingStore/updateGroupedDailyActivities", val);
			}
		},
		activity_type_list: {
			get() {
				return this.activityTypeList;
			},
			set(val) {
				this.$store.commit("SettingStore/updateActivityTypeList", val);
			}
		},
		activity_dialog_visible: {
			get() {
				return this.activityDialogVisible;
			},
			set(val) {
				this.$store.commit("SettingStore/updateActivityDialogVisible", val);
			}
		},
		activity_name: {
			get() {
				return this.activityName;
			},
			set(val) {
				this.$store.commit("SettingStore/updateActivityName", val);
			}
		},
		selected_activity: {
			get() {
				return this.selectedActivity;
			},
			set(val) {
				this.$store.commit("SettingStore/updateSelectedActivity", val);
			}
		},
		all_store_type: {
			get() {
				return this.allStoreType;
			},
			set(val) {
				this.$store.commit("SettingStore/updateAllStoreType", val);
			}
		},
		dine_in: {
			get() {
				return this.dineIn;
			},
			set(val) {
				this.$store.commit("SettingStore/updateDineIn", val);
			}
		},
		restroom: {
			get() {
				return this.isRestroom;
			},
			set(val) {
				this.$store.commit("SettingStore/updateIsRestroom", val);
			}
		},
		drive_through: {
			get() {
				return this.driveThrough;
			},
			set(val) {
				this.$store.commit("SettingStore/updateDriveThrough", val);
			}
		},
		delivery: {
			get() {
				return this.isDelivery;
			},
			set(val) {
				this.$store.commit("SettingStore/updateIsDelivery", val);
			}
		},
		is_daily_activites_loading: {
			get() {
				return this.isDailyActivitesLoading;
			},
			set(val) {
				this.$store.commit("SettingStore/updateIsDailyActivitesLoading", val);
			}
		},
		is_add_activity_in_progress: {
			get() {
				return this.isAddActivityInProgress;
			},
			set(val) {
				this.$store.commit("SettingStore/updateIsAddActivityInProgress", val);
			}
		},
		show_store_details_save_confirmation: {
			get() {
				return this.showStoreDetailsSaveConfirmation;
			},
			set(val) {
				this.$store.commit("SettingStore/updateShowStoreDetailsSaveConfirmation", val);
			}
		},
		store_details_save_choice: {
			get() {
				return this.storeDetailsSaveChoice;
			},
			set(val) {
				this.$store.commit("SettingStore/updateStoreDetailsSaveChoice", val);
			}
		},
		non_coverage_activity_hourly_view: {
			get() {
				return this.nonCoverageActivityHourlyView;
			},
			set(val) {
				this.$store.commit("SettingStore/updateNonCoverageActivityHourlyView", val);
			}
		},
		non_coverage_activity_hourly_view_summary: {
			get() {
				return this.nonCoverageActivityHourlyViewSummary;
			},
			set(val) {
				this.$store.commit("SettingStore/updateNonCoverageActivityHourlyViewSummary", val);
			}
		},
		selected_hourly_activities_ids: {
			get() {
				return this.selectedHourlyActivitiesIds;
			},
			set(val) {
				this.$store.commit("SettingStore/updateSelectedHourlyActivitiesIds", val);
			}
		},
		selected_hourly_view_days: {
			get() {
				return this.selectedHourlyViewDays;
			},
			set(val) {
				this.$store.commit("SettingStore/updateSelectedHourlyViewDays", val);
			}
		},
		selected_hourly_view_start_time: {
			get() {
				return this.selectedHourlyViewStartTime;
			},
			set(val) {
				this.$store.commit("SettingStore/updateSelectedHourlyViewStartTime", val);
			}
		},
		selected_hourly_view_end_time: {
			get() {
				return this.selectedHourlyViewEndTime;
			},
			set(val) {
				this.$store.commit("SettingStore/updateSelectedHourlyViewEndTime", val);
			}
		},
		selected_hourly_view_number_of_people: {
			get() {
				return this.selectedHourlyViewNumberOfPeople;
			},
			set(val) {
				this.$store.commit("SettingStore/updateSelectedHourlyViewNumberOfPeople", val);
			}
		},
		all_unique_hourly_activities() {
			let result = [...this.non_coverage_activity_hourly_view];
			let output = [...new Set(result.map(el => Object.keys(el.time_slot_and_function)).flat(1))];
			return output;
		},
		bulkEditHourlyFormDisabled() {
			let result = false;
			if(
				!this.selected_hourly_activities_ids.length ||
				!this.selected_hourly_view_start_time ||
				!this.selected_hourly_view_end_time ||
				!this.selected_hourly_view_days.length ||
				this.selected_hourly_view_number_of_people === null || 
				this.selected_hourly_view_number_of_people === ''
			) {
				result = true;
			}
			return result;
		},
		selected_hourly_filter_activities: {
			get() {
				return this.selectedHourlyFilterActivities;
			},
			set(val) {
				this.$store.commit("SettingStore/updateSelectedHourlyFilterActivities", val);
			}
		},
		selected_hourly_days: {
			get() {
				return this.selectedHourlyDays;
			},
			set(val) {
				this.$store.commit("SettingStore/updateSelectedHourlyDays", val);
			}
		},
		store_details_processing: {
      get() {
        return this.storeDetailsProcessing;
      },
      set(val) {
        this.$store.commit("CommonStore/updateStoreDetailsProcessing", val);
      }
    },
    store_processing_completed: {
      get() {
        return this.storeProcessingCompleted;
      },
      set(val) {
        this.$store.commit("CommonStore/updateStoreProcessingCompleted", val);
      }
    },
	checkCompany(){
		let companyIDs = localStorage.getItem('check_company');
		companyIDs = JSON.parse(companyIDs);
		return companyIDs;
	},
	},
	methods: {
		...mapActions("CommonStore", ["startProcessStatusPolling"]),
		generateTimeSlots() {
			var timeSlots = [];
			var hour, minute, period;
			
			for (hour = 0; hour < 24; hour++) {
				for (minute = 0; minute < 60; minute += 30) {
				if (hour < 12) {
					period = 'AM';
				} else {
					period = 'PM';
				}
			
				var formattedHour = (hour % 12 === 0) ? 12 : hour % 12;
				var formattedMinute = (minute === 0) ? '00' : minute;
			
				var value = formattedHour + ':' + formattedMinute + ' ' + period;
				var label = moment(value, 'hh:mm A').format('HH-mm');
			
				timeSlots.push({ label: label, value: value });
				}
			}
			
			return timeSlots;
		} ,
		getDayWiseTime(element) {
			console.log(element, 'element')
			let labels = [];
			let data = this.non_coverage_activity_hourly_view.length ? this.non_coverage_activity_hourly_view.find((e)=> e.day == element.day).timewise_sum : '';
			console.log(data, 'data');
			if(data){
				for (const key in data) {
					if (Object.hasOwnProperty.call(data, key)) {
						let elm = data[key];
						labels.push({label: key, value: moment(key, 'HH-mm').format('hh:mm A')});
						// if(key.split('-')[1]== '00'){
						// }
					}
				}
			}
			console.log(labels, 'labels')
			return labels;
		},
		updateStoreData(event) {
			EventBus.$emit("updateStoreData", event);
		},
		handleDayOpt(event){
			if(event.includes('all')){
				this.selected_hourly_days = [];
				this.selected_hourly_days.push('all');
			}
			console.log(event, 'event')
		},
		async getGroupedCoverageActivityList() {
			const params = {
				outlet: this.outlet,
			};
			this.coverage_table_loading = true;
			await labourPlanningService.getCompanyCoverageActivities(params)
			.then((response) => {
				let responseData = JSON.parse(response.data);
				this.updated_format_coverage_activities = responseData;
			})
			.catch((error) => {
				console.error(error);
			})
			.finally(err => {
				this.coverage_table_loading = false;
			});
		},
		editUpdatedCoverageActivity(section_id, index) {
			let check = this.updated_format_coverage_activities.find(el => el.section_id == section_id);
			if(check && check.section_setup[index]) {
				let sectionData = check.section_setup[index];
				if(!sectionData.add_time_by) {
					sectionData.add_time_by = [];
				}
				if(!sectionData.prep_time_overall || sectionData.prep_time_overall == [] || sectionData.prep_time_overall == {}) {
					sectionData.prep_time_overall = {
						hours: 0,
						minutes: 0,
						seconds: 0,
						store_id: this.outlet,
						department_id: null,
						function_id: this.updated_edit_coverage_activity.station_id,
						order_type: this.updated_edit_coverage_activity.order_type ? this.updated_edit_coverage_activity.order_type : [],
					};
				}
				sectionData.transaction_linked_activites = sectionData.transaction_linked_activites.map(el => ({
					...el,
					order_type: el.order_type ? el.order_type.length ? typeof(el.order_type) != "string" ? el.order_type : el.order_type.split(',') : ["all"] : ["all"]
				}));
				this.updated_edit_coverage_activity = {
					index_val: index,
					...sectionData
				};
				this.handleChangeCoverageActivityPlanningCriteria();
				this.hide_show_new_coverage_activity = true;
			}
		},
		closeEditUpdatedCoverageActivity() {
			this.updated_edit_coverage_activity = {};
			this.getGroupedCoverageActivityList();
			this.hide_show_new_coverage_activity = false;
		},
		removeUpdatedCoverageActivity(coverageActivity) {
			this.$confirm(`Do you really want to delete this activity?`, 'Warning!', {
				confirmButtonText: 'OK',
				dangerouslyUseHTMLString: true
			}).then(() => {
				const params = {
					outlet: this.outlet,
					daily_activity: coverageActivity.daily_activity.map(el => el.id),
					prep_time_categories: coverageActivity.prep_time_categories.map(el => el.id),
					prep_time_subcategories: coverageActivity.prep_time_subcategories.map(el => el.id),
					prep_time_departments: coverageActivity.prep_time_departments.map(el => el.id),
					prep_time_overall: coverageActivity.prep_time_overall && coverageActivity.prep_time_overall.id ? [coverageActivity.prep_time_overall.id] : [],
					transaction_linked_activites: coverageActivity.transaction_linked_activites.map(el => el.id),
					quantitiy_per_hour: coverageActivity.quantitiy_per_hour.map(el => el.id),
					footfall_per_hour: coverageActivity.footfall_per_hour.map(el => el.id),
					transaction_per_hour: coverageActivity.transaction_per_hour.map(el => el.id),
				};
				labourPlanningService.deleteUpdatedCoverageActivity(params)
				.then((res) => {
					this.getGroupedCoverageActivityList();
				}).catch(err => console.error(err));
			}).catch((err) => {
				// Do nothing
			});
		},
		openNewUpdatedCoverageActivity() {
			this.updated_edit_coverage_activity = {
				index_val: -1,
				section_id: null,
				station_id: null,
				min_workforce: 0,
				max_workforce: 0,
				station_name: "",
				add_time_by: [],
				quantitiy_per_hour: [],
				coverage_activity_enabled: true,
				"non-coverage_activity_enabled": false,
				planning_criteria: null,
				daily_activity: [],
				prep_time_categories: [],
				prep_time_subcategories: [],
				prep_time_departments: [],
				prep_time_overall: {
					hours: 0,
					minutes: 0,
					seconds: 0,
					store_id: this.outlet,
					department_id: null,
					function_id: this.updated_edit_coverage_activity.station_id,
					order_type: this.updated_edit_coverage_activity.order_type ? this.updated_edit_coverage_activity.order_type : "all",
				},
				transaction_linked_activites: [],
				transaction_per_hour: [],
				footfall_per_hour: [],
			};
			this.hide_show_new_coverage_activity = true;
		},
		saveUpdatedCoverageActivityData() {
			let localObj = {...this.updated_edit_coverage_activity};
			// VALIDATION STARTS
			// transaction activities
			localObj.transaction_linked_activites = localObj.transaction_linked_activites.filter(el => el.name && (el.hours || el.minutes || el.seconds)).map(el => ({
				...el,
				order_type: el.order_type ? el.order_type.length ? typeof(el.order_type) != 'string' ? el.order_type.sort((a, b) => a - b).join(',') : el.order_type : 'all' : 'all'
			}));
			// item prep time per hr
			/* prep time categories */
			localObj.prep_time_categories = localObj.prep_time_categories.filter(el => el.arr_field && el.arr_field.length && (el.hours || el.minutes || el.seconds)).map(el => ({
				...el,
				order_type: el.order_type ? el.order_type.length ? typeof(el.order_type) != 'string' ? el.order_type.sort((a, b) => a - b).join(',') : el.order_type : 'all' : 'all'
			}));
			/* prep time subcategories */
			localObj.prep_time_subcategories = localObj.prep_time_subcategories.filter(el => el.arr_field && el.arr_field.length && (el.hours || el.minutes || el.seconds)).map(el => ({
				...el,
				order_type: el.order_type ? el.order_type.length ? typeof(el.order_type) != 'string' ? el.order_type.sort((a, b) => a - b).join(',') : el.order_type : 'all' : 'all'
			}));
			/* prep time departments */
			localObj.prep_time_departments = localObj.prep_time_departments.filter(el => el.arr_field && el.arr_field.length && (el.hours || el.minutes || el.seconds)).map(el => ({
				...el,
				order_type: el.order_type ? el.order_type.length ? typeof(el.order_type) != 'string' ? el.order_type.sort((a, b) => a - b).join(',') : el.order_type : 'all' : 'all'
			}));
			/* prep time overall average time */
			if(localObj && localObj.prep_time_overall && (localObj.prep_time_overall.hours || localObj.prep_time_overall.minutes || localObj.prep_time_overall.seconds)) {
				localObj.prep_time_overall = localObj.prep_time_overall;
			} else {
				localObj.prep_time_overall = {};
			}
			// transaction per hr
			localObj.transaction_per_hour = localObj.transaction_per_hour.filter(el => el.range_requirement && (el.range_start || el.range_end)).map(el => ({
				...el,
				order_type: el.order_type ? el.order_type.length ? typeof(el.order_type) != 'string' ? el.order_type.sort((a, b) => a - b).join(',') : el.order_type : 'all' : 'all'
			}));
			// footfall per hr
			localObj.footfall_per_hour = localObj.footfall_per_hour.filter(el => el.range_requirement && (el.range_start || el.range_end)).map(el => ({
				...el,
				order_type: el.order_type ? el.order_type.length ? typeof(el.order_type) != 'string' ? el.order_type.sort((a, b) => a - b).join(',') : el.order_type : 'all' : 'all'
			}));
			// quantity per hr
			if(localObj.quantity_per_hour && localObj.quantity_per_hour.length) {
				localObj.quantity_per_hour = localObj.quantity_per_hour.filter(el => el.range_requirement && (el.range_start || el.range_end) && el.planning_level && ((el.applicable_categories && el.applicable_categories.length) || (el.applicable_subcategories && el.applicable_subcategories.length) || (el.applicable_departments && el.applicable_departments.length))).map(el => ({
					...el,
					order_type: el.order_type ? el.order_type.length ? typeof(el.order_type) != 'string' ? el.order_type.sort((a, b) => a - b).join(',') : el.order_type : 'all' : 'all'
				}));
			}
			// VALIDATION ENDS
			if(localObj.station_id && localObj.section_id) {
				let localArr = [...this.updated_format_coverage_activities];
				let check = localArr.findIndex(element => element.section_id == localObj.section_id);
				if(check === -1) {
					let localObjCopy = {...localObj};
					this.$delete(localObjCopy, 'index_val');
					localArr.push({
						"section_id": localObjCopy.section_id,
						"section_name": this.getSectionName(localObjCopy.section_id),
						"section_setup": [
							{...localObjCopy}
						]
					});
				} else {
					let checkStation = [...localArr[check].section_setup];
					if(checkStation && checkStation.length) {
						let localObjCopy = {...localObj};
						this.$delete(localObjCopy, 'index_val');
						if(localObj.index_val >= 0) {
							checkStation[localObj.index_val] = {...localObjCopy};
						} else if(localObj.index_val == -1) {
							checkStation.push(localObjCopy);
						}
					} else if(checkStation && checkStation.length == 0) {
						let localObjCopy = {...localObj};
						this.$delete(localObjCopy, 'index_val');
						checkStation.push({...localObjCopy});
					}
					localArr[check].section_setup = [...checkStation];
				}
				this.hide_show_new_coverage_activity = false;
				this.updated_format_coverage_activities = [...localArr];
				for(let i = 0; i < localArr.length; i++) {
					for(let j = 0; j < localArr[i].section_setup.length; j++) {
						if(this.updated_edit_coverage_activity.station_id == localArr[i].section_setup[j].station_id) {
							localArr[i].section_setup[j].min_workforce = this.updated_edit_coverage_activity.min_workforce;
							localArr[i].section_setup[j].max_workforce = this.updated_edit_coverage_activity.max_workforce;
						}
						localArr[i].section_setup[j].order_type = localArr[i].section_setup[j] ? localArr[i].section_setup[j].section_setup ? localArr[i].section_setup[j] ? localArr[i].section_setup[j].order_type ? localArr[i].section_setup[j].order_type.length ? localArr[i].section_setup[j].order_type.filter(el => el && el != '[]') : [] : [] : [] : [] : [];
						if(localArr[i].section_setup[j].planning_criteria == 'quantity per hr') {
							let quantity_per_hour_arr = [...localArr[i].section_setup[j].quantitiy_per_hour];
							for(let k = 0; k < quantity_per_hour_arr.length; k++) {
								if(quantity_per_hour_arr[k].planning_level == 'Department') {
									if(quantity_per_hour_arr[k].applicable_categories) {
										this.$delete(quantity_per_hour_arr[k], 'applicable_categories')
									}
									if(quantity_per_hour_arr[k].applicable_subcategories) {
										this.$delete(quantity_per_hour_arr[k], 'applicable_subcategories')
									}
								} else if(quantity_per_hour_arr[k].planning_level == 'Category') {
									if(quantity_per_hour_arr[k].applicable_departments) {
										this.$delete(quantity_per_hour_arr[k], 'applicable_departments')
									}
									if(quantity_per_hour_arr[k].applicable_subcategories) {
										this.$delete(quantity_per_hour_arr[k], 'applicable_subcategories')
									}
								} else if(quantity_per_hour_arr[k].planning_level == 'Subcategory') {
									if(quantity_per_hour_arr[k].applicable_departments) {
										this.$delete(quantity_per_hour_arr[k], 'applicable_departments')
									}
									if(quantity_per_hour_arr[k].applicable_categories) {
										this.$delete(quantity_per_hour_arr[k], 'applicable_categories')
									}
								}
							}
							localArr[i].section_setup[j].quantitiy_per_hour = [...quantity_per_hour_arr];
						}
					}
				}
				const params = {
					outlet: this.outlet,
					// data: [...this.updated_format_coverage_activities]
					data: localArr
				};
				// Call APIs
				labourPlanningService.createUpdateCoverageActivities(params)
					.then((response) => {
						this.getGroupedCoverageActivityList();
					})
					.catch((error) => {
						console.error(error);
					});
			}
		},
		handlePopulateOrderTypeDependency() {
			if(this.updated_edit_coverage_activity.planning_criteria == "item prep time per hr") {
				if(this.updated_edit_coverage_activity.add_time_by && this.updated_edit_coverage_activity.add_time_by.length) {
					if(this.updated_edit_coverage_activity.add_time_by[0] == 'Overall Average Time') {
						// this.updated_edit_coverage_activity.prep_time_overall = this.updated_edit_coverage_activity.prep_time_overall.map((el) => ({
						// 	...el,
						// 	order_type: this.updated_edit_coverage_activity.order_type
						// }));
						this.updated_edit_coverage_activity.prep_time_overall = {...this.updated_edit_coverage_activity.prep_time_overall, order_type: this.updated_edit_coverage_activity.order_type}
					} else if(this.updated_edit_coverage_activity.add_time_by[0] == 'Category') {
						this.updated_edit_coverage_activity.prep_time_categories = this.updated_edit_coverage_activity.prep_time_categories.map((el) => ({
							...el,
							order_type: this.updated_edit_coverage_activity.order_type
						}));
					} else if(this.updated_edit_coverage_activity.add_time_by[0] == 'Subcategory') {
						this.updated_edit_coverage_activity.prep_time_subcategories = this.updated_edit_coverage_activity.prep_time_subcategories.map((el) => ({
							...el,
							order_type: this.updated_edit_coverage_activity.order_type
						}));
					} else if(this.updated_edit_coverage_activity.add_time_by[0] == 'Department') {
						this.updated_edit_coverage_activity.prep_time_departments = this.updated_edit_coverage_activity.prep_time_departments.map((el) => ({
							...el,
							order_type: this.updated_edit_coverage_activity.order_type
						}));
					}
				}
			} else if(this.updated_edit_coverage_activity.planning_criteria == "transaction per hr") {
				this.updated_edit_coverage_activity.transaction_per_hour = this.updated_edit_coverage_activity.transaction_per_hour.map((el) => ({
					...el,
					order_type: this.updated_edit_coverage_activity.order_type
				}));
			}
		},
		openDailyView(){
			this.daily_activity_view = !this.daily_activity_view;
		},
		async getDesignation() {
			let params = {
				// store: this.storeDetailsId
				store: this.outlet,
			};
			await labourPlanningService
				.getDesignation(params)
				.then((response) => {
					let res = JSON.parse(response.data);
					this.storeDesignations = JSON.parse(JSON.stringify(res));
				})
				.catch((err) => {
					console.error(err);
				});
		},
		getDesignationName(id) {
			let designation = this.storeDesignations.find(el => el.id == id);
			if(designation) {
				return designation.name;
			} else {
				return "-";
			}
		},
		getTimeLabel(frequency) {
			if(frequency) {
				let check = this.frequency_hourly_value_list.find(el => el.value == frequency);
				if(check) {
					return check.title;
				} else {
					return frequency;
				}
			} else {
				return '-';
			}
		},
		getStoreDepartmentsAndFunctions() {
			if (this.outlet) {
				let params = {
					outlet_id: this.outlet,
				};
				return axios
					.all([
						labourPlanningService.getWorkArea(params),
						labourPlanningService.getStoreDepartments(params),
					])
					.then(
						axios.spread((functionRes, departmentRes) => {
							if (functionRes.status == 200 && departmentRes.status == 200) {
								// collect function list response
								if (JSON.parse(functionRes.data).length) {
									let function_list = JSON.parse(functionRes.data);

									this.storeFunctions = function_list.map((e) => {
										return {
											...e,
											title: e.function,
											is_selected: false,
										};
									});
								} else {
									this.storeFunctions = [];
								}

								// collect department list response
								if (JSON.parse(departmentRes.data).length) {
									this.storeDepartments = JSON.parse(departmentRes.data);
								} else {
									this.storeDepartments = [];
								}
							}
						})
					);
			}
		},
		async getLocations() {
			// await labourPlanningService
			// 	.getLocationHiererchy()
			// 	.then((response) => {
			// 		let data = JSON.parse(response.data).results;
			// 		data = JSON.parse(JSON.stringify(data));
			// 		for (let i in data) {
			// 			data[i].label = data[i].name;
			// 			data[i].value = data[i].id;
			// 			data[i].children = data[i].regions;
			// 			for (let j in data[i].children) {
			// 				data[i].children[j].label = data[i].children[j].name;
			// 				data[i].children[j].value = data[i].children[j].id;
			// 				data[i].children[j].children = data[i].children[j].subregions;
			// 				for (let k in data[i].children[j].children) {
			// 					data[i].children[j].children[k].label =
			// 						data[i].children[j].children[k].name;
			// 					data[i].children[j].children[k].value =
			// 						data[i].children[j].children[k].id;
			// 					data[i].children[j].children[k].children =
			// 						data[i].children[j].children[k].outlets;
			// 					for (let l in data[i].children[j].children[k].children) {
			// 						data[i].children[j].children[k].children[l].label =
			// 							data[i].children[j].children[k].children[l].name;
			// 						data[i].children[j].children[k].children[l].value =
			// 							data[i].children[j].children[k].children[l].id;
			// 					}
			// 				}
			// 			}
			// 		}
			// 		this.locationData = [...data];
			// 		// this.$store.commit(
			// 		// 	"LabourPlanning/SET_STORE_NAME",
			// 		// 	data[0].regions[0].subregions[0].outlets[0].id
			// 		// );
			// 	})
			// 	.catch((error) => {
			// 		console.error(error);
			// 	});
		},
		async getSections() {
			const payload = {
				store: this.outlet,
			};
			await labourPlanningService
				.getSections(payload)
				.then((res) => {
					let temp = JSON.parse(res.data);
					let localSections = temp.map(el => ({
						...el,
						setups_for_section: el.setups_for_section.map((element) => ({
							...element,
							function_name: this.getFunctionName(element.function)
						})),
						editable: false
					}));
					localSections.sort((a, b) => this.sortArray(a.name, b.name));
					this.sections = [...localSections];
				})
				.catch((error) => {
					console.error(error);
				});
		},
		sortArray(a, b) {
			const digitRegex = /^\d/;
			const alphabetRegex = /^[a-zA-Z]/;
			const symbolRegex = /^[^\w\s]/;

			const scoreA =  symbolRegex.test(a) * 1 || digitRegex.test(a) * 10 || alphabetRegex.test(a) * 100;
			const scoreB =  symbolRegex.test(b) * 1 || digitRegex.test(b) * 10 || alphabetRegex.test(b) * 100;

			if (scoreA !== scoreB) {
			  return scoreA - scoreB;
			}

			if (a < b) {
			  return -1;
			} else if (a > b) {
			  return 1;
			}

			return 0;
		},
		isEven(n) {
			return n % 2 == 0;
		},
		isOdd(n) {
			return Math.abs(n % 2) == 1;
		},
		openSection(row) {
			if (row) {
				this.sectionDetails = { ...row };
				this.showSections = true;
			} else {
				this.sectionDetails = {
					name: ""
				};
				this.showSections = true;
			}
		},
		deleteSection(id) {
			if (id) {
				let find = this.company_level_sections.find(el => el.id === id);
				if(find) {
					this.$confirm(
						"Are you sure to delete?",
						"Alert",
						{
							confirmButtonText: "Yes",
							cancelButtonText: "No",
							type: "warning",
							cancelButtonClass: "bg-success",
							confirmButtonClass: "bg-warning"
						}
					)
					.then(() => {
						labourPlanningService
							.deleteSectionAtCompanyLevel({ base_section: id })
							.then(async (res) => {
								await this.getAllSections();
								await this.getSections();
							})
							.catch((err) => console.error(err));
					})
					.catch((_) => {});
				}
			}
		},
		async getDailyActivities() {
			let obj = {
				outlet_id: this.outlet,
			};

			await labourPlanningService
				.getDailyActivities(obj)
				.then((response) => {
					let result = JSON.parse(response.data);
					this.raw_daily_activities = [...result];
					let format_data = [];
					for (let i = 0; i < result.length; i++) {
						let activity = result[i].activity_id;
						let station_id = result[i].function;
						let section_id = result[i].section;
						let check = format_data.findIndex(
							(el) => el.activity_id == activity && el.function == station_id && el.section == section_id
						);
						if (check === -1 || result[i].is_new_activity) {
							format_data.push({
								...result[i],
								function_name: this.getFunctionName(result[i].function),
								actions: [
									{
										action_id: result[i].id,
										plan_by: result[i].plan_by,
										hourly_freq: result[i].hourly_freq,
										weekly_freq: result[i].weekly_freq,
										monthly_freq: result[i].monthly_freq,
										days: result[i].days ? result[i].days : [],
										selected_time_units: result[i].selected_time_units
											? result[i].selected_time_units
											: [
													{
														start_time: null,
														end_time: null,
													},
											  ],
										number_of_people: result[i].number_of_people,
										duration: result[i].duration,
										duration_hrs: Math.floor(result[i].duration / 60),
										duration_mins: result[i].duration % 60,
										preferred_start_time: result[i].preferred_start_time,
										preferred_end_time: result[i].preferred_end_time,
									},
								],
								store_section: result[i].section,
								editable: result[i].editable ? result[i].editable : false,
							});
						} else {
							if(result[i].plan_by && result[i].selected_time_units && result[i].selected_time_units.length) {
								format_data[check].store_section = format_data[check].section;
								format_data[check].actions.push({
									action_id: result[i].id,
									plan_by: result[i].plan_by,
									hourly_freq: result[i].hourly_freq,
									days: result[i].days,
									weekly_freq: result[i].weekly_freq,
									monthly_freq: result[i].monthly_freq,
									selected_time_units: result[i].selected_time_units
										? result[i].selected_time_units
										: [
												{
													start_time: null,
													end_time: null,
												},
											],
									number_of_people: result[i].number_of_people,
									duration: result[i].duration,
									duration_hrs: Math.floor(result[i].duration / 60),
									duration_mins: result[i].duration % 60,
									preferred_start_time: result[i].preferred_start_time,
									preferred_end_time: result[i].preferred_end_time,
								});
							}
						}
					}
					this.dailyActivityList = format_data.map(el => {
						let objItem = {...el};
						if(objItem.store) {
							this.$delete(objItem, "store");
						}
						return objItem;
					});
					this.groupSectionalFunctionalActivities();
				})
				.catch((err) => {
					console.error(err);
				});
		},
		groupSectionalFunctionalActivities() {
			let rawData = [...this.dailyActivityList];
			const params = rawData.reduce((r, a) => {
				r[a.section] = r[a.section] || [];
				r[a.section].push(a);
				return r;
			}, Object.create(null));
			let updatedObj = {};
			for(let prop in params) {
				const value = params[prop].reduce((r, a) => {
					r[a.function] = r[a.function] || [];
					r[a.function].push({...a, activity_name: this.getActivityName(a.activity_id)});
					return r;
				}, Object.create(null));
				updatedObj[prop] = value;
			}
			this.grouped_daily_activities = {...updatedObj};
		},
		async getNonCoverageActivities() {
			let params = {
				store: this.outlet
			};
			await labourPlanningService.getStoreSectionFunctions(params)
			.then(response => {
				let responseData = JSON.parse(response.data);
				this.nonCoverageActivitiesList = responseData.map(el => ({
					...el,
					editable: false
				}));
			}).catch(error => {
				console.error(error);
			});
		},
		async bulkDeleteDailyActivities(daily_activities) {
			await labourPlanningService.deleteDailyActivities(daily_activities)
			.then(async (response) => {
				await this.getDailyActivities();
				await this.getNonCoverageActivities();
			})
			.catch(error => {
				console.error(error);
			});
		},
		async getCoverageActivities() {
			let params = {
				outlet_id: this.outlet,
			};
			await labourPlanningService
				.getAutoStoreDetails(params)
				.then((response) => {
					this.storeDetailsId = JSON.parse(response.data).id;

					this.store_planning_criteria = JSON.parse(
						response.data
					).store_planning_criteria;

					this.plan_type = JSON.parse(response.data).function_based_requirements;

					this.workforce_planning_type = JSON.parse(response.data)
						.store_planning_criteria
						? JSON.parse(response.data).store_planning_criteria
						: "item prep time per hr";

					if (this.plan_type) {
						labourPlanningService.getFunctionalActivities(params).then(
							axios.spread(
								(
									department,
									functionsList,
									preparation,
									transaction,
									daily,
									hoursList,
									activityTypeListRes
								) => {
									let functions = JSON.parse(functionsList.data);

									let preparationActivities = JSON.parse(preparation.data);

									let transaction_list = JSON.parse(transaction.data);

									let daily_list = JSON.parse(daily.data);

									let hrsList = JSON.parse(hoursList.data);

									let temp = functions.map((func) => {
										let obj = {
											activity_list: [],
											transaction_list: [],
											daily_list: [],
											hrsList: [],
											function: "",
											function_id: null,
											department: null,
											is_overall: null,
											section: func.section,
											activities: {
												title: "",
												activities_data: [],
												duration: [],
												time: "",
											},

											transaction_activities: {
												title: "",
												activities_data: [],
												duration: [],
												time: "",
											},

											daily_activities: {
												title: "",
												activities_data: [],
												duration: [],
												time: "",
											},

											hrs_List: {
												title: "",
												activities_data: [],
												duration: [],
											},
										};

										let prepHour = 0;
										let prepMin = 0;
										let prepsec = 0;

										preparationActivities.map((activity) => {
											if (func.id == activity.function) {
												if (activity.category) {
													this.categoryList.map((cat) => {
														if (cat.id == activity.category) {
															activity.name = cat.name;
															obj.activities.activities_data.push({
																name: cat.name,
																id: activity.category,
															});
														}
													});
												}

												if (activity.product_department) {
													this.department_list.map((product) => {
														if (product.id == activity.product_department) {
															activity.name = product.name;

															obj.activities.activities_data.push({
																name: product.name,
																id: activity.product_department,
															});
														}
													});
												}

												obj.activity_list.push(activity);
												obj.function = func.function;
												obj.is_overall = activity.category ? 2 : 1;
												obj.function_id = func.id;
												obj.store_section = activity.section ? activity.section : activity.store_section;
												obj.section = activity.section;
												obj.department = func.store_department;
												obj.department_name = this.getDepartmentName(
													func.store_department ? func.store_department : null
												);
												obj.planning_type = func.planning_criteria;
												obj.activities.title = "Preparation";
												prepHour += activity.hours;
												prepMin += activity.minutes;
												prepsec += activity.seconds;
												obj.activities.time = `${prepHour}:${prepMin}:${prepsec}`;
												obj.activities.duration.push(
													`${
														String(activity.hours).length > 1
															? activity.hours
															: "0" + activity.hours
													}:${
														String(activity.minutes).length > 1
															? activity.minutes
															: "0" + activity.minutes
													}:${
														String(activity.seconds).length > 1
															? activity.seconds
															: "0" + activity.seconds
													}`
												);
											}
										});
										let tranHour = 0;
										let tranMin = 0;
										let transec = 0;

										transaction_list.map((tran) => {
											if (func.id == tran.function) {
												obj.transaction_list.push(tran);
												obj.function = func.function;
												obj.function_name = obj.function_name =
													this.getFunctionName(
														func.function ? func.function : null
													);
												obj.function_id = func.id;
												obj.department = func.store_department;
												obj.department_name = this.getDepartmentName(
													func.store_department ? func.store_department : null
												);
												obj.planning_type = func.planning_criteria;
												obj.transaction_activities.title =
													"Transaction Activity";
												obj.transaction_activities.activities_data.push({
													name: tran.name,
												});
												tranHour += tran.hours;
												tranMin += tran.minutes;
												transec += tran.seconds;
												obj.transaction_activities.time = `${tranHour}:${tranMin}:${transec}`;
												obj.transaction_activities.duration.push(
													`${
														String(tran.hours).length > 1
															? tran.hours
															: "0" + tran.hours
													}:${
														String(tran.minutes).length > 1
															? tran.minutes
															: "0" + tran.minutes
													}:${
														String(tran.seconds).length > 1
															? tran.seconds
															: "0" + tran.seconds
													}`
												);
											}
										});

										let dailyHour = "";
										let dailyMin = "";
										let dailysec = "";

										daily_list.map((daily) => {
											if (func.id == daily.function) {
												obj.daily_list.push(daily);
												obj.function = func.function;
												obj.function_name = obj.function_name =
													this.getFunctionName(
														func.function ? func.function : null
													);
												obj.function_id = func.id;
												obj.department = func.store_department;
												obj.department_name = this.getDepartmentName(
													func.store_department ? func.store_department : null
												);
												obj.planning_type = func.planning_criteria;
												obj.daily_activities.title = "Daily Activity";
												obj.daily_activities.activities_data.push({
													name: daily.name,
												});
												dailyHour += daily.hours ? daily.hours : "";
												dailyMin += daily.minutes ? daily.minutes : "";
												dailysec += daily.seconds ? daily.seconds : "";
												obj.daily_activities.time = `${dailyHour}:${dailyMin}:${dailysec}`;

												obj.daily_activities.duration.push(
													`${
														String(daily.hours).length > 1
															? daily.hours
															: "0" + daily.hours
													}:${
														String(daily.minutes).length > 1
															? daily.minutes
															: "0" + daily.minutes
													}:${
														String(daily.seconds).length > 1
															? daily.seconds
															: "0" + daily.seconds
													}`
												);
											}
										});

										hrsList.map((hrs) => {
											if (func.id == hrs.function) {
												hrs.start = this.generateRange(0, 1000, 1);
												hrs.end = this.generateRange(hrs.range_start, 1000, 1);
												obj.hrsList.push(hrs);
												obj.function = func.function;
												obj.section = hrs.section ? hrs.section : hrs.store_section;
												obj.store_section = hrs.section ? hrs.section : hrs.store_section;
												obj.function_name = this.getFunctionName(
													func.function ? func.function : null
												);
												obj.function_id = func.id;
												obj.department = func.store_department;
												obj.department_name = this.getDepartmentName(
													func.store_department ? func.store_department : null
												);
												obj.planning_type = func.planning_criteria
													? func.planning_criteria
													: hrs.basis;
												obj.hrs_List.title = hrs.basis;
												obj.hrs_List.activities_data.push({
													name: `${hrs.range_start} To ${hrs.range_end}`,
												});
											}
										});
										return obj;
									});

									this.coverageActivityList = temp.filter((e) => {
										if (e.function) {
											return e;
										}
									});

									this.selectedFunctionList = this.coverageActivityList.map(el => {
										return el.function_id;
									})
								}
							)
						);
					} else {
						labourPlanningService
							.getActivities(params)
							.then((response) => {
								this.activity_list = JSON.parse(response.data);
								if (this.activity_list.overall_avg_time) {
									this.overall_average = this.activity_list.overall_avg_time;
									this.addTime = 1;
								}
								this.contingency = this.activity_list.contingency;
								if (this.activity_list.daily_activities.length) {
									this.dailyActivity = this.activity_list.daily_activities;
									this.showdaily = true;
								} else {
									this.dailyActivity = [
										{
											name: "",
											time: "",
											type: "",
											task_frequency: "",
											total_time: "",
										},
									];
								}
								if (this.activity_list.transaction_linked_activities.length) {
									this.transactionActivity =
										this.activity_list.transaction_linked_activities;
									this.showtransaction = true;
								} else {
									this.transactionActivity = [
										{
											name: "",
											time: "",
										},
									];
								}
								if (this.activity_list.avg_time_per_category.length) {
									this.preparationActivity =
										this.activity_list.avg_time_per_category;
									this.showcategory = true;
									this.addTime = 2;
									this.selectedList = [];
									for (var i in this.preparationActivity) {
										this.selectedList.push(
											this.preparationActivity[i].category
										);
									}
								}

								this.loaddingPage = false;
							})
							.catch((err) => {
								console.error(err);
								this.loaddingPage = false;
							});

						labourPlanningService
							.getFunctionPerHrsAct(params)
							.then((response) => {
								let tempList = JSON.parse(response.data);
								if (tempList.length) {
									for (let i = 0; i < tempList.length; i++) {
										tempList[i].start = this.generateRange(0, 1000, 1);
										tempList[i].end = this.generateRange(
											tempList[i].range_start,
											1000,
											1
										);
										if (tempList[i].function == null) {
											this.numTeancList.push(tempList[i]);
										}
									}
								} else {
									this.numTeancList = [
										{
											function: "",
											basis: "",
											range_start: 0,
											range_end: 0,
											start: this.generateRange(0, 1000, 1),
											end: this.generateRange(0, 1000, 1),
											range_requirement: 0,
										},
									];
								}
							})
							.catch((err) => {
								console.error(err);
								// this.loaddingPage = false;
							});
					}
				})
				.catch((err) => {
					console.error(err);
					// this.loaddingPage = false;
				});
		},
		async getAllCategory() {
			await labourPlanningService.getAllCategory()
				.then(response => {
					this.categoryList = JSON.parse(response.data);
				})
				.catch(err => {
					console.error(err);
				});
		},
		async getAllSubCategories() {
			await labourPlanningService.getAllSubCategories()
				.then(response => {
					this.subcategory_list = JSON.parse(response.data);
				})
				.catch(err => {
					console.error(err);
				});
		},
		generateRange(min, max, step) {
			let arr = [];
			for (let i = min; i <= max; i += step) {
				arr.push(i);
			}
			return arr;
		},
		getDepartmentName(id) {
			let department = this.storeDepartments.find((el) => el.id == id);
			if (department) {
				return department.department;
			} else {
				return "-";
			}
		},
		getFunctionName(id) {
			let department = this.storeFunctions.find((el) => el.id == id);
			if (department) {
				return department.function;
			} else {
				return "-";
			}
		},
		getSectionName(id) {
			let section = this.sections.find((el) => el.id == id);
			if (section) {
				return section.name;
			} else {
				return "-";
			}
		},
		getOutletName(id) {
			let department = this.outletLists.find((el) => el.id == id);
			if (department) {
				return department.name;
			} else {
				return "-";
			}
		},
		async getAllOutlets() {
			const outlet_id = localStorage.getItem("store_id") || localStorage.getItem("store");
			await labourPlanningService
				.getAllStoreData()
				.then((response) => {
					let res = JSON.parse(response.data);
					res.sort((a, b) => a.name - b.name);
					this.outletLists = res;
					if(this.isCompanySettingsPage) {
						let check = this.outletLists.find(el => el.type == 'head_office');
						if(check !== undefined) {
							this.outlet = check.id;
							localStorage.setItem('store_id', this.outlet);
						} else if(this.outletLists.length) {
							this.outlet = this.outletLists[0].id;
							localStorage.setItem('store_id', this.outlet);
						}
					} else {
						console.log(outlet_id, 'outlet_idoutlet_idoutlet_id')
						if(!outlet_id) {
							this.outlet = this.outletLists.filter(el => el.type != 'head_office')[0].id;
							localStorage.setItem('store_id', this.outlet);
						} else {
							this.outlet = outlet_id;
							// let tempOutlet = localStorage.getItem("store_id");
							// let check = this.outletLists.find(el => el.id == tempOutlet);
							// if(check !== undefined) {
							// 	if(check.type == 'head_office') {
							// 		let localOutletList = this.outletLists.filter(el => el.type != 'head_office');
							// 		this.outlet = localOutletList[0].id;
							// 		localStorage.setItem("store_id", localOutletList[0].id);
							// 	} else {
							// 		this.outlet = tempOutlet;
							// 	}
							// } else {
							// 	let localOutletList = this.outletLists.filter(el => el.type != 'head_office');
							// 	this.outlet = localOutletList[0].id;
							// 	localStorage.setItem("store_id", localOutletList[0].id);
							// }
						}
					}
					this.generalSettingsStore = this.outlet;
					EventBus.$emit("updateStoreData", this.outlet);
				})
				.catch((err) => console.error(err));
		},
		async getHeadOfficeOutlets(){
			await labourPlanningService
				.getHeadOfficeOutlets()
				.then((response) => {
					let head_office_id = JSON.parse(response.data).results.find((e)=> e.type==="head_office").id;
					this.head_office_id = head_office_id;
					localStorage.setItem('head_office_id', head_office_id);
				}).catch((err)=>{
					
				})
		},
		openAddCoverageActivity(index = undefined, val = undefined) {
			if (this.outlet) {
				this.showCoverageActivityModal = true;
				if (index >= 0 && val) {
					this.coverageActivityDetail = { ...val[index] };
				}
			} else {
				this.$notify.error({
					title: "Failed",
					message: "Please select an outlet first",
				});
			}
		},
		addCategory() {
			if (this.avgTimePerCategory.length != this.categoryList.length) {
				this.avgTimePerCategory.push({
					category: [],
					subcategory: [],
					transaction_threshold: [],
					higher_threshold: 0,
					lower_threshold: 0,
					hours: "",
					minutes: "",
					seconds: "",
					store_section: this.selected_section,
				});
			}
		},
		addSubCategory() {
			this.sub_category_activity_list.push({
				id: "",
				function: "",
				department: "",
				category: "",
				subcategory: [],
				transaction_threshold: [],
				higher_threshold: 0,
				lower_threshold: 0,
				hours: "",
				minutes: "",
				seconds: "",
			});
		},
		addTransactionThreshold(subcategory_index) {
			this.sub_category_activity_list[
				subcategory_index
			].transaction_threshold.push({
				higher_threshold: 0,
				lower_threshold: 0,
				hours: "",
				minutes: "",
				seconds: "",
			});
		},
		generateRange(min, max, step) {
			let arr = [];
			for (let i = min; i <= max; i += step) {
				arr.push(i);
			}
			return arr;
		},
		addNewTransactionActivity() {
			this.transactionActivities.push({
				name: "",
				function: this.selected_functions,
				order_type: [],
				hours: 0,
				minutes: 0,
				seconds: 0,
			});
		},
		async addHourActivity() {
			await this.addPlanningType(this.selected_functions);
			// await this.saveStorePlane();

			let plan =
				this.planning_type == "transaction per hr"
					? "Transaction"
					: this.planning_type == "footfall per hr"
					? "Footfall"
					: this.planning_type == "quantity"
					? "Quantity"
					: "item prep time per hr";

			let order_type = [];

			// if order type is all then sent blank string
			if (this.order_type.length) {
				if (
					this.planning_type == "item prep time per hr" ||
					this.planning_type == "footfall per hr"
				) {
					order_type = [];
				} else {
					if (this.order_type.indexOf("all") > -1) {
						order_type = [];
					} else {
						// order_type = this.order_type.join(); // throwing error
						order_type = this.order_type;
					}
				}
			} else {
				order_type = [];
			}

			let params = this.numTeancList.map((el) => {
				let obj = {
					function: this.selected_functions,
					basis: plan,
					department: null,
					range_start: el.range_start,
					range_end: el.range_end,
					range_requirement: el.range_requirement,
					order_type: order_type,
					store_section: this.selected_section,
				};

				el.id ? (obj.id = el.id) : "";

				if (
					this.planning_type == "quantity" &&
					this.planning_level == "category"
				) {
					obj.applicable_categories = this.selectedCategories.length
						? this.selectedCategories
						: [];
				} else if (
					this.planning_type == "quantity" &&
					this.planning_level == "department"
				) {
					obj.applicable_im_departments = this.select_planning_level_department
						.length
						? this.select_planning_level_department
						: [];
				} else if (
					this.planning_type == "quantity" &&
					this.planning_level == "subcategory"
				) {
					obj.applicable_im_subcategories = this.selected_sub_categories.length
						? this.selected_sub_categories
						: [];
				}

				return obj;
			});

			let hourParams = {
				store: this.outlet,
				data: params,
			};

			await labourPlanningService
				.addHourActivities(hourParams)
				.then(async (response) => {
					this.closePopup();
					this.$notify.success({
						title: "Success",
						message: "Activities updated succesfully",
					});
					this.numTeancList = [
						{
							function: null,
							basis: "",
							range_start: 0,
							range_end: 0,
							start: this.generateRange(0, 1000, 1),
							end: this.generateRange(0, 1000, 1),
							range_requirement: 0,
						},
					];
					this.selectedCategories = [];
					this.selected_sub_categories = [];
					await this.addUpdateNewActivity();
					await this.getCoverageActivities();
				})
				.catch((err) => {
					console.error(err);
				})
				.finally(result => {
					this.resetCoverageActivityModalData();
				});
		},
		addPlanningType(value) {
			let type = this.planning_type.toLowerCase();
			if (this.planning_type == "quantity") {
				type = "quantity per hr";
			}
			let params = {
				planning_criteria: type,
				store: this.outlet,
			};
			value ? (params.function = this.selected_functions) : "";
			labourPlanningService
				.addPlanningType(params)
				.then((res) => {
					// this.getEmployeeFunctions();
				})
				.catch((err) => {
					console.error("err", err);
				});
		},
		getEmployeeFunctions() {
			if (this.outlet) {
				let params = {
					outlet_id: this.outlet,
				};

				labourPlanningService.getDepartment(params).then((response) => {
					this.departmentList = JSON.parse(response.data);
					this.filterDepartmentList = this.departmentList.map((e) => {
						return {
							title: e.department,
							id: e.id,
							is_selected: false,
						};
					});
				});
			}
		},
		autoFillCategory() {
			this.preparationActivity = [];
			for (var i in this.categoryList) {
				this.preparationActivity.push({
					function: "",
					department: "",
					category: this.categoryList[i].id,
					hours: "0",
					minutes: "0",
					seconds: "0",
				});
			}
			this.changeKeys = true;
		},
		async addActivity() {
			if (this.addTime && this.selected_functions) {
				let obj = {
					activity_list: [],
					department_list: [],
					transaction_list: [],
					daily_list: [],
					hrsList: [],
					function: null,
					planning_type: this.planning_type,
					function_id: null,
					department: null,
					is_overall: null,

					activities: {
						title: "",
						activities_data: [],
						duration: [],
						time: "",
						higher_threshold: 0,
						lower_threshold: 0,
					},
					department_activities: {
						title: "",
						activities_data: [],
						duration: [],
						time: "",
					},
					transaction_activities: {
						title: "",
						activities_data: [],
						duration: [],
						time: "",
					},
					daily_activities: {
						title: "",
						activities_data: [],
						duration: [],
						time: "",
					},
					hrs_List: {
						title: "",
						activities_data: [],
						duration: [],
					},
				};

				let temp = this.functions.map((func) => {
					if (func.id == this.selected_functions) {
						if (this.addTime == 1 || this.addTime == 2) {
							let prepHour = 0;
							let prepMin = 0;
							let prepsec = 0;

							let transaction_threshold = [];

							this.avgTimePerCategory.map((activity) => {
								let name = "";
								let category_id = "";
								let categories = [];
								let id = activity.id;

								this.categoryList.map((cat) => {
									// categories.push(cat.id);
									categories = activity.category.slice();
									activity.category.map((subcat) => {
										if (cat.id == subcat) {
											name = cat.name;
											category_id = subcat;
										}
									});
								});

								// new structure
								let threshold_obj = {
									name: name,
									category_id: category_id,
									id: id,
									higher_threshold: activity.higher_threshold,
									lower_threshold: activity.lower_threshold,
									hours: Number(activity.hours),
									minutes: Number(activity.minutes),
									seconds: Number(activity.seconds),
									function: this.selected_functions,
									department: this.selected_department,
									category: categories,
								};

								transaction_threshold.unshift(threshold_obj);

								activity.transaction_threshold.forEach((e) => {
									let inner_threshold_obj = {
										name: name,
										category_id: category_id,
										id: e.id,
										higher_threshold: e.higher_threshold,
										lower_threshold: e.lower_threshold,
										hours: Number(e.hours),
										minutes: Number(e.minutes),
										seconds: Number(e.seconds),
										function: this.selected_functions,
										department: this.selected_department,
										category: categories,
									};

									transaction_threshold.unshift(inner_threshold_obj);
								});
							});

							for (let i = 0; i < transaction_threshold.length; i++) {
								obj.activities.activities_data.push({
									name: transaction_threshold[i].name,
									id: transaction_threshold[i].category_id,
								});

								obj.activity_list.push(transaction_threshold[i]);
							}
							obj.is_overall = this.addTime;
							obj.function = func.function;
							obj.function_id = func.id;
							obj.department = func.store_department;
							obj.planning_type = this.planning_type;
							obj.activities.title = "Preparation";
						}

						if (this.addTime == 3) {
							let hours = 0;
							let mins = 0;
							let secs = 0;

							this.department_activities.map((dept) => {
								if (dept.product_department) {
									this.department_list.map((product) => {
										if (product.id == dept.product_department) {
											dept.name = product.name;

											obj.activities.activities_data.push({
												name: product.name,
												id: dept.product_department,
											});
										}
									});

									dept.function = this.selected_functions;
									dept.department = this.selected_department;
									dept.product_department = dept.product_department;

									obj.activity_list.push(dept);
									obj.function = func.function;
									obj.function_id = func.id;
									obj.department = func.store_department;
									obj.planning_type = this.planning_type;
									obj.activities.title = "Preparation";

									hours += dept.hours;
									mins += dept.minutes;
									secs += dept.seconds;

									obj.activities.time = `${hours}:${mins}:${secs}`;

									obj.activities.duration.push(
										`${
											String(dept.hours).length > 1
												? dept.hours
												: "0" + dept.hours
										}:${
											String(dept.minutes).length > 1
												? dept.minutes
												: "0" + dept.minutes
										}:${
											String(dept.seconds).length > 1
												? dept.seconds
												: "0" + dept.seconds
										}`
									);
								}
							});
						}

						if (this.addTime == 4) {
							let prepHour = 0;
							let prepMin = 0;
							let prepsec = 0;

							let transaction_threshold = [];

							this.sub_category_activity_list.map((activity) => {
								let name = "";
								let subcategory_id = "";
								let subcategories = [];
								let id = activity.id;

								this.subcategory_list.map((cat) => {
									subcategories = activity.subcategory.slice();

									activity.subcategory.map((subcat) => {
										if (cat.id == subcat) {
											name = cat.name;
											subcategory_id = subcat;
										}
									});
								});

								let threshold_obj = {
									name: name,
									subcategory_id: subcategory_id,
									id: id,
									higher_threshold: activity.higher_threshold,
									lower_threshold: activity.lower_threshold,
									hours: Number(activity.hours),
									minutes: Number(activity.minutes),
									seconds: Number(activity.seconds),
									function: this.selected_functions,
									department: this.selected_department,
									subcategory: subcategories,
								};

								transaction_threshold.unshift(threshold_obj);

								activity.transaction_threshold.forEach((e) => {
									let inner_threshold_obj = {
										name: name,
										subcategory_id: subcategory_id,
										id: e.id,
										higher_threshold: e.higher_threshold,
										lower_threshold: e.lower_threshold,
										hours: Number(e.hours),
										minutes: Number(e.minutes),
										seconds: Number(e.seconds),
										function: this.selected_functions,
										department: this.selected_department,
										subcategory: subcategories,
									};

									transaction_threshold.unshift(inner_threshold_obj);
								});
							});

							for (let i = 0; i < transaction_threshold.length; i++) {
								obj.activities.activities_data.push({
									name: transaction_threshold[i].name,
									id: transaction_threshold[i].subcategory_id,
								});

								obj.activity_list.push(transaction_threshold[i]);
							}
							obj.is_overall = this.addTime;
							obj.function = func.function;
							obj.function_id = func.id;
							obj.department = func.store_department;
							obj.planning_type = this.planning_type;
							obj.activities.title = "Preparation";
						}

						return obj;
					}
				});

				let filterlist = temp.filter((el) => {
					if (el) {
						return el;
					}
				});

				if (this.selectedIndex !== null) {
					this.coverageActivityList.splice(this.selectedIndex, 1, filterlist[0]);
				} else {
					this.coverageActivityList.push(filterlist[0]);
				}

				this.filterActivity = this.coverageActivityList;

				await this.addPlanningType(this.selected_functions);
			// await this.saveStorePlane();
				await this.addPreparationActivities();
				await this.addTransactionActivities();
				await this.addUpdateNewActivity();
				await this.closePopup();
				await this.resetCoverageActivityModalData();
			}
		},
		openPopUp() {
			this.changeKeys = true;
		},
		addDepartmentActivity() {
			this.department_activities.push({
				id: "",
				function: "",
				department: "",
				product_department: "",
				category: "",
				hours: "",
				minutes: "",
				seconds: "",
			});
		},
		selectDepartment(department_id, index, event) {
			if (this.selected_department_list.indexOf(department_id) == -1) {
				this.selected_department_list.splice(index, 1, department_id);
			}
		},
		addTransactionObj() {
			// if (this.numTeancList[this.numTeancList.length - 1].range_end) {
			// 	let array = this.generateRange(
			// 		this.numTeancList[this.numTeancList.length - 1].range_end,
			// 		1000,
			// 		1
			// 	);
			// 	this.numTeancList.push({
			// 		function: null,
			// 		basis: "Transaction",
			// 		range_start: 0,
			// 		start: array,
			// 		end: array,
			// 		range_end: 0,
			// 		range_requirement: 0,
			// 	});
			// } else {
			// 	let array = this.generateRange(0, 2000, 10);
			// 	this.numTeancList.push({
			// 		function: null,
			// 		basis: "Transaction",
			// 		range_start: 0,
			// 		start: array,
			// 		end: array,
			// 		range_end: 0,
			// 		range_requirement: 0,
			// 	});
			// }
			if(this.updated_edit_coverage_activity.planning_criteria == 'quantity per hr') {
				this.updated_edit_coverage_activity.quantitiy_per_hour.push({
					planning_level: "Category",
					applicable_categories: [],
					order_type: this.updated_edit_coverage_activity.order_type ? this.updated_edit_coverage_activity.order_type : null,
					range_start: 0,
					range_end: 0,
					range_requirement: 0,
				});
				this.updated_edit_coverage_activity.transaction_per_hour = [];
				this.updated_edit_coverage_activity.footfall_per_hour = [];
			} else if(this.updated_edit_coverage_activity.planning_criteria == 'transaction per hr') {
				this.updated_edit_coverage_activity.transaction_per_hour.push({
					store_id: this.outlet,
					department_id: null,
					function_id: this.updated_edit_coverage_activity.station_id,
					basis: "Transaction",
					order_type: this.updated_edit_coverage_activity.order_type ? this.updated_edit_coverage_activity.order_type : null,
					range_start: 0,
					range_end: 0,
					range_requirement: 0,
				});
				this.updated_edit_coverage_activity.quantitiy_per_hour = [];
				this.updated_edit_coverage_activity.footfall_per_hour = [];
			} else if(this.updated_edit_coverage_activity.planning_criteria == 'footfall per hr') {
				this.updated_edit_coverage_activity.transaction_per_hour = [];
				this.updated_edit_coverage_activity.quantitiy_per_hour = [];
				this.updated_edit_coverage_activity.footfall_per_hour.push({
					store_id: this.outlet,
					department_id: null,
					function_id: this.updated_edit_coverage_activity.station_id,
					basis: "Footfall",
					order_type: this.updated_edit_coverage_activity.order_type ? this.updated_edit_coverage_activity.order_type : null,
					range_start: 0,
					range_end: 0,
					range_requirement: 0,
				});
			}
		},
		getOrderTypes() {
			return labourPlanningService
				.getOrderTypes()
				.then((response) => {
					this.order_type_list = JSON.parse(response.data);
				})
				.catch((err) => {
					console.error(err);
				});
		},
		async getDepartmentList() {
			await labourPlanningService
				.getDepartmentList()
				.then((response) => {
					let res = JSON.parse(response.data);
					if (res.length) {
						this.departmentList = JSON.parse(JSON.stringify(res));
					} else {
						this.departmentList = [];
					}
				})
				.catch((err) => {
					console.error(err);
				});
		},
		openNonCoverageActivity() {
			if (this.outlet) {
				this.showNonCoverageActivity = true;
			} else {
				this.$notify.error({
					title: "Failed",
					message: "Please select an outlet first",
				});
			}
		},
		sentenceCase(str) {
			return str.replace(/\w\S*/g, function (txt) {
				return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
			});
		},
		addMoreTransactionCoverageActivity() {
			this.updated_edit_coverage_activity.transaction_linked_activites.push({
				store_id: this.outlet,
				department_id: null,
				function_id: this.updated_edit_coverage_activity.station_id,
				order_type : [],
				name: "",
				hours: 0,
				minutes: 0,
				seconds: 0,
			});
		},
		removeTransactionActivity(transactionActivityIndex) {
			this.$delete(this.updated_edit_coverage_activity.transaction_linked_activites, transactionActivityIndex);
			if(!this.updated_edit_coverage_activity.transaction_linked_activites.length) {
				this.updated_edit_coverage_activity.transaction_linked_activites.push({
					store_id: this.outlet,
					department_id: null,
					function_id: this.updated_edit_coverage_activity.station_id,
					order_type : [],
					name: "",
					hours: 0,
					minutes: 0,
					seconds: 0,
				});
			}
		},
		addMoreDepartmentActivities() {
			this.updated_edit_coverage_activity.prep_time_departments.push({
				department: null,
				order_type: this.updated_edit_coverage_activity.order_type ? this.updated_edit_coverage_activity.order_type : [],
				lower_threshold: 0,
				higher_threshold: 0,
				hours: 0,
				minutes: 0,
				seconds: 0,
				arr_field: [],
			});
		},
		deleteDepartmentActivities(departmentActivityIndex) {
			this.$delete(this.updated_edit_coverage_activity.prep_time_departments, departmentActivityIndex);
			if(!this.updated_edit_coverage_activity.prep_time_departments.length) {
				this.updated_edit_coverage_activity.prep_time_departments.push({
					department: null,
					order_type: this.updated_edit_coverage_activity.order_type ? this.updated_edit_coverage_activity.order_type : [],
					lower_threshold: 0,
					higher_threshold: 0,
					hours: 0,
					minutes: 0,
					seconds: 0,
					arr_field: [],
				});
			}
		},
		addMoreSubcategoryActivities() {
			if(this.updated_edit_coverage_activity.prep_time_subcategories) {
				this.updated_edit_coverage_activity.prep_time_subcategories.push({
					department: null,
					order_type: this.updated_edit_coverage_activity.order_type ? this.updated_edit_coverage_activity.order_type : [],
					lower_threshold: 0,
					higher_threshold: 0,
					hours: 0,
					minutes: 0,
					seconds: 0,
					arr_field: [],
				});
			}
		},
		deleteSubcategoryItem(subcategoryIndex) {
			if(
				this.updated_edit_coverage_activity.prep_time_subcategories &&
				this.updated_edit_coverage_activity.prep_time_subcategories.length &&
				this.updated_edit_coverage_activity.prep_time_subcategories[subcategoryIndex]
			) {
				this.$delete(this.updated_edit_coverage_activity.prep_time_subcategories, subcategoryIndex);
			}
			if(this.updated_edit_coverage_activity.prep_time_subcategories && this.updated_edit_coverage_activity.prep_time_subcategories.length == 0) {
				this.updated_edit_coverage_activity.prep_time_subcategories.push({
					department: null,
					order_type: this.updated_edit_coverage_activity.order_type ? this.updated_edit_coverage_activity.order_type : [],
					lower_threshold: 0,
					higher_threshold: 0,
					hours: 0,
					minutes: 0,
					seconds: 0,
					arr_field: [],
				});
			}
		},
		addMoreCategoryActivities() {
			this.updated_edit_coverage_activity.prep_time_categories.push({
				department: null,
				order_type: this.updated_edit_coverage_activity.order_type ? this.updated_edit_coverage_activity.order_type : [],
				lower_threshold: 0,
				higher_threshold: 0,
				hours: 0,
				minutes: 0,
				seconds: 0,
				arr_field: [],
			});
		},
		deleteCategoryItem(categoryIndex) {
			if(
				this.updated_edit_coverage_activity.prep_time_categories &&
				this.updated_edit_coverage_activity.prep_time_categories.length &&
				this.updated_edit_coverage_activity.prep_time_categories[categoryIndex]
			) {
				this.$delete(this.updated_edit_coverage_activity.prep_time_categories, categoryIndex);
			}
			if(this.updated_edit_coverage_activity.prep_time_categories.length == 0) {
				this.updated_edit_coverage_activity.prep_time_categories.push({
					department: null,
					order_type: this.updated_edit_coverage_activity.order_type ? this.updated_edit_coverage_activity.order_type : [],
					lower_threshold: 0,
					higher_threshold: 0,
					hours: 0,
					minutes: 0,
					seconds: 0,
					arr_field: [],
				});
			}
		},
		closePopup() {
			this.showCoverageActivityModal = false;
		},
		saveStorePlane() {
			let storeParams = {
				function_based_requirements: this.plan_type,
				store: this.outlet
			};
			labourPlanningService.updateOrCreateStorePlan(this.outlet, storeParams)
				.then(response => {
					if (response.status == 200) {
					}
				})
				.catch(err => {
					console.error(err);
				});
		},
		addPreparationActivities() {
			let temp = [];

			let paramsPrepAct = [];
			for (let i = 0; i < this.coverageActivityList.length; i++) {
				if (this.coverageActivityList[i].is_overall == 2 && this.addTime == 2) {

					for (let j = 0; j < this.coverageActivityList[i].activity_list.length; j++) {
						let obj = {
							function: this.coverageActivityList[i].activity_list[j].function,
							department: this.coverageActivityList[i].activity_list[j].department == 'DefaultDept' ? null : this.coverageActivityList[i].activity_list[j].department,
							category: this.coverageActivityList[i].activity_list[j].category,
							is_overall: false,
							product_department: null,
							hours: this.coverageActivityList[i].activity_list[j].hours ? this.coverageActivityList[i].activity_list[j].hours : 0,
							minutes: this.coverageActivityList[i].activity_list[j].minutes ? this.coverageActivityList[i].activity_list[j].minutes : 0,
							seconds: this.coverageActivityList[i].activity_list[j].seconds ? this.coverageActivityList[i].activity_list[j].seconds : 0,
							higher_threshold: this.coverageActivityList[i].activity_list[j].higher_threshold,
							lower_threshold: this.coverageActivityList[i].activity_list[j].lower_threshold,
							store_section: this.selected_section
						};

						if (this.coverageActivityList[i].activity_list[j].id) {
							obj.id = this.coverageActivityList[i].activity_list[j].id;
						}

						if (obj.category && obj.category.length) {
							temp.push(obj);
						}
					}

				} else if (this.addTime == 1) {
					let obj = {
						function: this.coverageActivityList[i].function_id,
						department: this.coverageActivityList[i].department == 'DefaultDept' ? null : this.coverageActivityList[i].department,
						// category: null,
						category: [],
						is_overall: true,
						hours: this.overall_average.hours ? this.overall_average.hours : 0,
						minutes: this.overall_average.minutes ? this.overall_average.minutes : 0,
						seconds: this.overall_average.seconds ? this.overall_average.seconds : 0,
						store_section: this.selected_section
					};
					temp.push(obj);

				} else if (this.addTime == 3) {
					if (this.coverageActivityList[i].activity_list && this.coverageActivityList[i].activity_list.length) {

						for (let j = 0; j < this.coverageActivityList[i].activity_list.length; j++) {
							let obj = {
								function: this.coverageActivityList[i].activity_list[j].function,
								department: this.coverageActivityList[i].activity_list[j].department == 'DefaultDept' ? null : this.coverageActivityList[i].activity_list[j].department,
								// category: '',
								category: [],
								is_overall: false,
								product_department: this.coverageActivityList[i].activity_list[j].product_department,
								hours: this.coverageActivityList[i].activity_list[j].hours ? this.coverageActivityList[i].activity_list[j].hours : 0,
								minutes: this.coverageActivityList[i].activity_list[j].minutes ? this.coverageActivityList[i].activity_list[j].minutes : 0,
								seconds: this.coverageActivityList[i].activity_list[j].seconds ? this.coverageActivityList[i].activity_list[j].seconds : 0,
								store_section: this.selected_section
							};

							if (this.coverageActivityList[i].activity_list[j].id) {
								obj.id = this.coverageActivityList[i].activity_list[j].id;
							}

							if (obj.product_department != null) {
								temp.push(obj);
							}
						}
					}
				} else if (this.addTime == 4) {
					if (this.coverageActivityList[i].activity_list && this.coverageActivityList[i].activity_list.length) {

						for (let j = 0; j < this.coverageActivityList[i].activity_list.length; j++) {
							let obj = {
								function: this.coverageActivityList[i].activity_list[j].function,
								department: this.coverageActivityList[i].activity_list[j].department,
								category: [],
								subcategory: this.coverageActivityList[i].activity_list[j].subcategory,
								is_overall: false,
								product_department: null,
								hours: this.coverageActivityList[i].activity_list[j].hours ? this.coverageActivityList[i].activity_list[j].hours : 0,
								minutes: this.coverageActivityList[i].activity_list[j].minutes ? this.coverageActivityList[i].activity_list[j].minutes : 0,
								seconds: this.coverageActivityList[i].activity_list[j].seconds ? this.coverageActivityList[i].activity_list[j].seconds : 0,
								higher_threshold: this.coverageActivityList[i].activity_list[j].higher_threshold,
								lower_threshold: this.coverageActivityList[i].activity_list[j].lower_threshold,
								store_section: this.selected_section
							};
							if (this.coverageActivityList[i].activity_list[j].id) {
								obj.id = this.coverageActivityList[i].activity_list[j].id;
							}

							if (obj.subcategory && obj.subcategory.length) {
								temp.push(obj);
							}
						}
					}
				}
			}

			paramsPrepAct = temp.filter(el => {
				if (el.category || el.is_overall || el.product_department || el.subcategory) {
					return el;
				}
			});

			let params = {
				store: this.outlet,
				data: paramsPrepAct
			};

			labourPlanningService.addPreparationActivities(params)
				.then(response => {
					this.getCoverageActivities();
				})
				.catch(err => {
					console.error(err);
				});
		},
		addTransactionActivities() {
			let paramsTrancAct = [];
			paramsTrancAct = this.transactionActivities.filter(el => {
				if (el.name) {
					return el;
				}
			});
			let params = {
				store: this.outlet,
				data: paramsTrancAct.map(el => {
					let obj = {
						...el,
						store_section: this.selected_section
					};
					if(obj.id == "") {
						this.$delete(obj, 'id');
					}
				}).filter(el => el)
			};
			if(paramsTrancAct.length > 0 && paramsTrancAct[0].name && paramsTrancAct.length && params.data.length) {
				labourPlanningService.addTransactionActivities(params)
					.then(response => {
						// this.getAllCategory();
					})
					.catch(err => {
						console.error(err);
					});
			}
		},
		addUpdateNewActivity() {
			if(this.selected_functions) {
				// Transaction Activities
				var transactionActivityParams = [];
				this.transactionActivities.map(el => {
					if(this.selected_functions && el.name && el.order_type && (el.hours || el.minutes || el.seconds)) {
						let temp = {
							name: el.name,
							function: this.selected_functions,
							order_type: el.order_type,
							hours: el.hours,
							minutes: el.minutes,
							seconds: el.seconds,
						};
						if(el.id) {
							temp.id = el.id;
						}
						transactionActivityParams.push(temp)
					}
				});
				if(transactionActivityParams.length) {
					const secondParams = {
						store: this.selectedOutlet,
						data: transactionActivityParams.map((el) => ({
							...el,
							store_section: this.selected_section
						}))
					}
						labourPlanningService.addTransactionActivities(secondParams)
						.then(response => {
							console.warn(response.data);
						})
						.catch(error => {
							console.error(error);
						});
				}
			}
		},
		// Delete coverage activity
		deleteActivity(
			activity,
			transaction,
			daily,
			id,
			department,
			hrsList,
			item,
			index) {

				this.$confirm(`Do you wish to delete this activity?`, "Alert!", {
					confirmButtonText: "Yes",
					cancelButtonText: "No",
					type: "warning",
					cancelButtonClass: "bg-success",
					confirmButtonClass: "bg-warning"
				})
				.then(() => {
					if (hrsList.length) {
						for (let i = 0; i < hrsList.length; i++) {
							labourPlanningService.deleteTrancAndFFootfallHour({ id: hrsList[i].id })
								.then(response => { })
								.catch(err => {
									console.error(err);
								});
						}

						this.getCoverageActivities();
					}

					if (activity.length) {
						let category_activity = [];
						let subcategory_activity = [];
						let department_activity = [];

						for (let i = 0; i < activity.length; i++) {
							if (activity[i].category) {
								category_activity.push(activity[i].category);
							} else if (activity[i].subcategory) {
								subcategory_activity.push(activity[i].subcategory);
							} else if (activity[i].product_department) {
								department_activity.push(activity[i].category);
							}
						}

						if (category_activity.length) {
							for (let i = 0; i < activity.length; i++) {
								labourPlanningService.deleteAvgTimes({ id: activity[i].id })
									.then(response => {
									});
							}

						} else if (subcategory_activity.length) {
							for (let i = 0; i < activity.length; i++) {
								labourPlanningService.deleteAvgTimesSubCategory({ id: activity[i].id })
									.then(response => {
									});
							}

						} else if (department_activity.length) {
							for (let i = 0; i < activity.length; i++) {
								labourPlanningService.deleteDeparmentActivity({ id: activity[i].id })
									.then(response => {
									});
							}
						}

						this.getCoverageActivities();
					}

					if (transaction.length) {
						for (let i = 0; i < transaction.length; i++) {
							labourPlanningService.deleteLinkeds({ id: transaction[i].id })
								.then(response => {
								});
						}

						this.getCoverageActivities();
					}

					if (daily.length) {
						for (let i = 0; i < daily.length; i++) {
							labourPlanningService.deleteDailys([{ id: daily[i].id }])
								.then(response => {
								});
						}

						this.getCoverageActivities();
					}
				}).catch(() => {});

			// this.Activity.splice(index, 1);
		},
		// Edit coverage activity
		editActivity(activity, transaction, daily, id, department, hrsList, item, index) {
			if (item.planning_type == "quantity per hr") {
				this.planning_type = "quantity";
			} else {
				this.planning_type = item.planning_type;
			}

			this.check_duplicated_subcategories = [];
			this.functionBaseselectedList = [];
			this.addTime = item.is_overall;

			if (this.addTime == 1) {
				if (activity.length) {
					this.overall_average.hours = activity[0].hours;
					this.overall_average.minutes = activity[0].minutes;
					this.overall_average.seconds = activity[0].seconds;
				}
			}

			this.selectedIndex = index;
			this.addActivityPopup = true;
			this.selected_functions = id;
			this.selected_department = department;
			this.selected_section = item.section ? Number(item.section) : item.store_section;

			if (department) {
				this.filterFunctionByDepartment(department);
			} else {
				this.filterFunctions = this.functions;
			}

			if (activity.length) {
				let category_activities = [];
				let subcategory_activities = [];
				let departmental_activities = [];

				for (let i in activity) {
					this.functionBaseselectedList.push(activity[i].category);

					if (activity[i].category) {
						category_activities.push(activity[i].category);
					} else if (activity[i].subcategory) {
						subcategory_activities.push(activity[i].subcategory);
					} else if (activity[i].product_department) {
						departmental_activities.push(activity[i].product_department);
					}
				}


				if (category_activities.length) {
					this.addTime = 2;

					let temp_activity = _.uniqBy(activity, 'group_id');

					for (let i = 0; i < temp_activity.length; i++) {
						this.$set(temp_activity[i], 'transaction_threshold', []);

						temp_activity[i].transaction_threshold = activity.filter(e => {
							return e.group_id == temp_activity[i].group_id && e.id != temp_activity[i].id;
						});
					}

					this.avgTimePerCategory = JSON.parse(JSON.stringify(temp_activity));

				}

				if (subcategory_activities.length) {
					this.addTime = 4;

					let temp_activity = _.uniqBy(activity, 'group_id');

					let structured_subcategories = [];

					for (let i = 0; i < temp_activity.length; i++) {
						this.$set(temp_activity[i], 'transaction_threshold', []);

						temp_activity[i].transaction_threshold = activity.filter(e => {
							return e.group_id == temp_activity[i].group_id && e.id != temp_activity[i].id;
						});

						for (let j = 0; j < temp_activity[i].subcategory.length; j++) {
							if (this.check_duplicated_subcategories.indexOf(temp_activity[i].subcategory[j]) == -1) {
								this.check_duplicated_subcategories.push(temp_activity[i].subcategory[j]);
							}
						}
					}
					this.sub_category_activity_list = JSON.parse(JSON.stringify(temp_activity));

				} else if (departmental_activities.length) {
					this.addTime = 3;

					this.department_activities = JSON.parse(JSON.stringify(activity));
				}

			} else {
				this.avgTimePerCategory = [
					{
						function: null,
						department: null,
						category: [],
						subcategory: [],
						transaction_threshold: [],
						higher_threshold: 0,
						lower_threshold: 0,
						hours: "",
						minutes: "",
						seconds: "",
						store_section: this.selected_section
					}
				];

				this.department_activities = [
					{
						id: "",
						function: "",
						department: "",
						product_department: "",
						category: "",
						hours: "",
						minutes: "",
						seconds: "",
						store_section: this.selected_section
					}
				];
			}

			if (transaction.length) {
				this.transactionActivities = transaction;
			} else {
				this.transactionActivities = [
					{
						function: null,
						department: null,
						name: "",
						hours: "",
						minutes: "",
						seconds: ""
					}
				];
			}

			if (daily.length) {
				this.dailyActivityList = JSON.parse(JSON.stringify(daily));
			} else {
				this.dailyActivityList = [
					{
						name: "",
						function: null,
						department: null,
						hours: "",
						minutes: "",
						seconds: "",
						total_duration: "",
						task_frequency: ""
					}
				];
			}

			if (hrsList.length) {

				for (let i = 0; i < hrsList.length; i++) {
					if (hrsList[i].basis == "Quantity") {
						this.selectedCategories = hrsList[i].applicable_categories;
						this.select_planning_level_department = hrsList[i].applicable_im_departments;
						this.selected_sub_categories = hrsList[i].applicable_im_subcategories;

						if (this.selectedCategories.length) {
							this.planning_level = 'category';
						} else if (this.selected_sub_categories.length) {
							this.planning_level = 'subcategory';
						} else if (this.select_planning_level_department.length) {
							this.planning_level = 'department';
						}
					}
					if (i == 0) {
						hrsList[i].start = this.generateRange(0, 1000, 1);
						hrsList[i].end = this.generateRange(hrsList[i].range_start, 1000, 1);

						if (hrsList[i].order_type != null) {
							// this.order_type = hrsList[i].order_type.length ? hrsList[i].order_type.split(',') : '';
							// this.order_type = hrsList[i].order_type.length > 1 ? hrsList[i].order_type.split(',') : hrsList[i].order_type.length ? hrsList[i].order_type[0] : '';
							this.order_type = hrsList[i].order_type;
						} else {
							this.order_type = ["all"];
						}

					} else {
						hrsList[i].start = this.generateRange(Number(hrsList[i - 1].range_end) + 1, 1000, 1)
						hrsList[i].end = this.generateRange(Number(hrsList[i].range_start) + 1, 1000, 1)
					}
				}

				this.numTeancList = JSON.parse(JSON.stringify(hrsList));
			} else {
				this.numTeancList = [
					{
						function: null,
						department: null,
						basis: "",
						range_start: 0,
						range_end: 0,
						start: this.generateRange(0, 1000, 1),
						end: this.generateRange(0, 1000, 1),
						range_requirement: 0
					}
				];
			}
			this.openAddCoverageActivity();
		},
		filterFunctionByDepartment(department, check) {
			this.filterFunctions = this.functions.filter(el => {
				if (department == el.store_department) {
					return el;
				}
			});
		},
		toggleFunctionMapping(item) {
			this.section_function_data = {...item};
			// this.addOrEditSectionStationMapping();
			this.addOrUpdateSection();
		},
		addOrEditSectionStationMapping() {
			let payload = {
				store: this.outlet
			};
			let daily_activities = [];
			let local_section_function_data = {...this.section_function_data};
			this.$delete(local_section_function_data, "store");
			this.raw_daily_activities.forEach(el => {
				let obj = {
					activity_id: el.activity_id,
					department_id: el.department_id,
					designation: el.designation,
					duration: el.duration,
					frequency: el.frequency,
					function: el.function,
					hourly_freq: el.hourly_freq,
					id: el.id,
					monthly_freq: el.monthly_freq,
					number_of_people: el.number_of_people,
					plan_by: el.plan_by,
					preferred_end_time: el.preferred_end_time,
					preferred_start_time: el.preferred_start_time,
					section: el.section,
					selected_time_units: el.selected_time_units,
					store_section: el.section,
					time_frame: el.time_frame,
					weekly_freq: el.weekly_freq,
				}
				daily_activities.push(obj);
			});
			let index = daily_activities.findIndex(el => el.id == local_section_function_data.id);
			if(index !== -1) {
				daily_activities[index] = {...local_section_function_data};
				payload.data = [...daily_activities];
				labourPlanningService.addOrUpdateDailyActivities(payload)
				.then(response => {
					this.showNonCoverageActivity = false;
				}).catch(error => {
					console.error(error);
				}).finally(async (res) => {
					await this.getDailyActivities();
					await this.getNonCoverageActivities();
				});
			} else {
				payload.data = [...daily_activities, {
					section: this.section_function_data.section,
					store_section: this.section_function_data.section,
					function: this.section_function_data.function,
				}];
				labourPlanningService.addOrUpdateDailyActivities(payload)
				.then(response => {
					this.showNonCoverageActivity = false;
				}).catch(error => {
					console.error(error);
				}).finally(async (res) => {
					await this.getDailyActivities();
					await this.getNonCoverageActivities();
				});
			}

		},
		editNonCoverageActivity(obj=undefined) {
			if(obj) {
				this.section_function_data = {...obj, store_section: obj.section, activities: []};
			} else {
				this.section_function_data = {
					id: null,
					designation: null,
					function: null,
					duration: 0,
					frequency: "daily",
					hourly_freq: "0.0",
					weekly_freq: [
						"monday",
						"tuesday",
						"wednesday",
						"thursday",
						"friday",
						"saturday",
						"sunday",
					],
					monthly_freq: [],
					selected_time_units: [{ end_time: "00:00", start_time: "00:00" }],
					time_frame: "operation_hours",
					plan_by: "no_of_people",
					preferred_start_time: null,
					preferred_end_time: null,
					number_of_people: 0,
					section: null,
					store_section: null,
					activity_id: null,
					department_id: null,
					function_name: "",
					actions: [
						{
							action_id: null,
							plan_by: "no_of_people",
							hourly_freq: "0.0",
							weekly_freq: [
								"monday",
								"tuesday",
								"wednesday",
								"thursday",
								"friday",
								"saturday",
								"sunday",
							],
							monthly_freq: [],
							selected_time_units: [{ end_time: "00:00", start_time: "00:00" }],
							number_of_people: 0,
							duration: 0,
							duration_hrs: 0,
							duration_mins: 0,
							preferred_start_time: null,
							preferred_end_time: null,
						},
					],
					editable: false,
					activities: []
				};
			}
			this.showNonCoverageActivity = true;
		},
		async addOrUpdateSection(section_id = 0) {
			let sections_data = [...this.sections];
			if(section_id > 0) {
				let finIndex = sections_data.findIndex(el => el.id == section_id);
				if(finIndex !== -1) {
					sections_data[finIndex].setups_for_section.forEach((el, ind) => {
						sections_data[finIndex].setups_for_section[ind].enabled = sections_data[finIndex].enabled;
					});
				}
			}
			let params = {
				store: this.outlet,
				sections_data: sections_data
			}
			return await labourPlanningService.addSections(params)
			.then(async (response) => {
				await this.getSections();
			})
			.catch((err) => console.error(err));
		},
		resetSectionDetails() {
			this.sectionDetails = {
				name: "",
			}
		},
		// Store guidelines
		getStaffDetails() {
			const param = {
				outlet_id: this.outlet
			};
			return labourPlanningService
				.getStaffDetails(param)
				.then((response) => {
					let staffDetails = JSON.parse(response.data);
					staffDetails.min_shift_gap = staffDetails.min_shift_gap.slice(0, 5);
					this.staff_details = {...staffDetails};
				})
				.catch((error) => {
					console.error(error);
				});
		},
		saveStoreStaffDetails() {
			const params = {
				...this.staff_details
			};
			labourPlanningService
				.addStaffDetails(params)
				.then((response) => {
					this.getStaffDetails();
				})
				.catch((error) => {
					console.error(error);
				});
		},
		getAllSections() {
			const result = labourPlanningService.getSectionsAtCompanyLevel();
				result.then((response) => {
					this.company_level_sections = JSON.parse(response.data);
				})
				.catch((error) => {
					console.error(error);
				});
		},
		addNewSection(event) {
			if(event == 'add new') {
				this.selected_section = "";
				this.sectionDetails = {
					title: ""
				};
				this.updated_edit_coverage_activity.section_id = "";
				this.showSections = true;
			}
		},
		addNewStation(event) {
			if(event == 'add new') {
				this.selected_functions = "";
				this.station_details = {
					title: ""
				};
				this.updated_edit_coverage_activity.station_id = "";
				this.hide_show_station_add_edit_popup = true;
			}
		},
		editStation(station_details) {
			this.selected_functions = "";
			this.station_details = {
				...station_details
			};
		},
		addUpdatestoreFunction() {
			if(this.outlet) {
				let functions = [...this.functions];
				if(this.station_details.id) {
					let funcIndex = functions.findIndex((el) => el.id === this.station_details.id);
					if(funcIndex !== -1) {
						functions[funcIndex] = {
							...this.station_details,
							function: this.station_details.title,
							short_name: this.station_details.title,
						};
					} else if(this.station_details.title) {
						functions.push({
							function: this.station_details.title,
							short_name: this.station_details.title,
							store_department: null,
							hierarchy: 0,
							store_operations_hour: 0,
							pre_opening_min_required: 0,
							post_closing_min_required: 0,
							restricted_hours_min_required: 0,
							overlap_required: "no",
							maximum_deployable: 0,
							planning_criteria: null,
							interchangeable_functions: [],
							section: null,
							is_daily_activity: false,
							title: this.station_details.title,
							is_selected: false,
						});
					}
				} else if(this.station_details.title) {
					functions.push({
						function: this.station_details.title,
						short_name: this.station_details.title,
						store_department: null,
						hierarchy: 0,
						store_operations_hour: 0,
						pre_opening_min_required: 0,
						post_closing_min_required: 0,
						restricted_hours_min_required: 0,
						overlap_required: "no",
						maximum_deployable: 0,
						planning_criteria: null,
						interchangeable_functions: [],
						section: null,
						is_daily_activity: false,
						title: this.station_details.title,
						is_selected: false,
					});
				}
				let params = {
					store: this.outlet,
					data: [...functions]
				};
				labourPlanningService
					.addWorkArea(params)
					.then(async (response) => {
						await this.getStoreDepartmentsAndFunctions();
						this.station_details = {
							"title": ""
						};
						this.$notify.success({
							title: "Success",
							message: "Station updated succesfully"
						});
					})
					.catch(err => {
						console.error(err);
					});
			}
		},
		deleteStoreStation(id) {
			if(id) {
				this.$confirm(`Do you wish to delete this station?`, "Alert!", {
					confirmButtonText: "Yes",
					cancelButtonText: "No",
					type: "warning",
					cancelButtonClass: "bg-success",
					confirmButtonClass: "bg-warning"
				})
				.then(() => {
					labourPlanningService.deleteFunctions({id: id})
						.then(async (response) => {
							await this.getStoreDepartmentsAndFunctions();
						})
						.catch((err) => console.error(err));
				}).catch(err => {});
			}
		},
		updateNonCoverageActivityDailyView(index, timeIndex, event) {
			this.coverageActivitiesDailyViewData[index].timings[timeIndex] = event;
		},
		// deleteHourTrancAndFootfall(id, index) {
		deleteHourTrancAndFootfall(id, index) {
			// if (id) {
			// 	labourPlanningService.deleteTrancAndFFootfallHour({ id: id })
			// 		.then(response => {
			// 			this.numTeancList.splice(index, 1);
			// 		})
			// 		.catch(err => {
			// 			console.error(err);
			// 		});
			// } else {
			// 	this.numTeancList.splice(index, 1);
			// }
			if(this.updated_edit_coverage_activity.planning_criteria == "quantity per hr") {
				if(this.updated_edit_coverage_activity.quantitiy_per_hour && this.updated_edit_coverage_activity.quantitiy_per_hour.length && this.updated_edit_coverage_activity.quantitiy_per_hour[index]) {
					this.$delete(this.updated_edit_coverage_activity.quantitiy_per_hour, index);
				}
				if(this.updated_edit_coverage_activity.quantitiy_per_hour && this.updated_edit_coverage_activity.quantitiy_per_hour.length == 0) {
					this.updated_edit_coverage_activity.quantitiy_per_hour.push({
						planning_level: "Category",
						applicable_categories: [],
						order_type: this.updated_edit_coverage_activity.order_type ? this.updated_edit_coverage_activity.order_type : [],
						range_start: 0,
						range_end: 0,
						range_requirement: 0,
					});
				}
			} else if(this.updated_edit_coverage_activity.planning_criteria == "transaction per hr") {
				if(this.updated_edit_coverage_activity.transaction_per_hour && this.updated_edit_coverage_activity.transaction_per_hour.length && this.updated_edit_coverage_activity.transaction_per_hour[index]) {
					this.$delete(this.updated_edit_coverage_activity.transaction_per_hour, index);
				}
				if(this.updated_edit_coverage_activity.transaction_per_hour && this.updated_edit_coverage_activity.transaction_per_hour.length == 0) {
					this.updated_edit_coverage_activity.transaction_per_hour.push({
						store_id: this.outlet,
						department_id: null,
						function_id: this.updated_edit_coverage_activity.station_id,
						basis: "Transaction",
						order_type: this.updated_edit_coverage_activity.order_type ? this.updated_edit_coverage_activity.order_type : [],
						range_start: 0,
						range_end: 0,
						range_requirement: 0,
					});
				}
			} else if(this.updated_edit_coverage_activity.planning_criteria == "footfall per hr") {
				if(this.updated_edit_coverage_activity.footfall_per_hour && this.updated_edit_coverage_activity.footfall_per_hour.length && this.updated_edit_coverage_activity.footfall_per_hour[index]) {
					this.$delete(this.updated_edit_coverage_activity.footfall_per_hour, index);
				}
				if(this.updated_edit_coverage_activity.footfall_per_hour && this.updated_edit_coverage_activity.footfall_per_hour.length == 0) {
					this.updated_edit_coverage_activity.footfall_per_hour.push({
						store_id: this.outlet,
						department_id: null,
						function_id: this.updated_edit_coverage_activity.station_id,
						basis: "Footfall",
						order_type: this.updated_edit_coverage_activity.order_type ? this.updated_edit_coverage_activity.order_type : [],
						range_start: 0,
						range_end: 0,
						range_requirement: 0,
					});
				}
			}
		},
		handleChangeCoverageActivityPlanningCriteria() {
			if(this.updated_edit_coverage_activity.planning_criteria == 'quantity per hr') {
				if(this.updated_edit_coverage_activity.quantitiy_per_hour && this.updated_edit_coverage_activity.quantitiy_per_hour.length == 0) {
					this.updated_edit_coverage_activity.quantitiy_per_hour.push({
						planning_level: "Category",
						applicable_categories: [],
						order_type: this.updated_edit_coverage_activity.order_type ? this.updated_edit_coverage_activity.order_type : null,
						range_start: 0,
						range_end: 0,
						range_requirement: 0,
					});
				}
				this.updated_edit_coverage_activity.transaction_per_hour = [];
				this.updated_edit_coverage_activity.footfall_per_hour = [];
			} else if(this.updated_edit_coverage_activity.planning_criteria == 'transaction per hr') {
				if(this.updated_edit_coverage_activity.transaction_per_hour && this.updated_edit_coverage_activity.transaction_per_hour.length == 0) {
					this.updated_edit_coverage_activity.transaction_per_hour.push({
						store_id: this.outlet,
						department_id: null,
						function_id: this.updated_edit_coverage_activity.station_id,
						basis: "Transaction",
						order_type: this.updated_edit_coverage_activity.order_type ? this.updated_edit_coverage_activity.order_type : null,
						range_start: 0,
						range_end: 0,
						range_requirement: 0,
					});
				}
				this.updated_edit_coverage_activity.quantitiy_per_hour = [];
				this.updated_edit_coverage_activity.footfall_per_hour = [];
			} else if(this.updated_edit_coverage_activity.planning_criteria == 'footfall per hr') {
				if(this.updated_edit_coverage_activity.footfall_per_hour && this.updated_edit_coverage_activity.footfall_per_hour.length == 0) {
					this.updated_edit_coverage_activity.footfall_per_hour.push({
						store_id: this.outlet,
						department_id: null,
						function_id: this.updated_edit_coverage_activity.station_id,
						basis: "Footfall",
						order_type: this.updated_edit_coverage_activity.order_type ? this.updated_edit_coverage_activity.order_type : null,
						range_start: 0,
						range_end: 0,
						range_requirement: 0,
					});
				}
				this.updated_edit_coverage_activity.quantitiy_per_hour = [];
				this.updated_edit_coverage_activity.transaction_per_hour = [];
			}
			if(this.updated_edit_coverage_activity.transaction_linked_activites && this.updated_edit_coverage_activity.transaction_linked_activites.length == 0) {
				this.updated_edit_coverage_activity.transaction_linked_activites.push({
					store_id: this.outlet,
					department_id: null,
					function_id: this.updated_edit_coverage_activity.station_id,
					order_type : [],
					name: "",
					hours: 0,
					minutes: 0,
					seconds: 0,
				});
			}
		},
		handleChangeAddTimeBy() {
			if(this.updated_edit_coverage_activity.add_time_by && this.updated_edit_coverage_activity.add_time_by.length) {
				if(this.updated_edit_coverage_activity.add_time_by[0] == 'Overall Average Time') {
					if(this.updated_edit_coverage_activity.prep_time_overall && (Object.keys(this.updated_edit_coverage_activity.prep_time_overall) == 0)) {
						this.updated_edit_coverage_activity.prep_time_overall = {
							hours: 0,
							minutes: 0,
							seconds: 0,
							store_id: this.outlet,
							department_id: null,
							function_id: this.updated_edit_coverage_activity.station_id,
							order_type: this.updated_edit_coverage_activity.order_type ? this.updated_edit_coverage_activity.order_type : [],
						};
					}
					this.updated_edit_coverage_activity.prep_time_categories = [];
					this.updated_edit_coverage_activity.prep_time_subcategories = [];
					this.updated_edit_coverage_activity.prep_time_departments = [];
					this.updated_edit_coverage_activity.transaction_per_hour = [];
					this.updated_edit_coverage_activity.quantitiy_per_hour = [];
					this.updated_edit_coverage_activity.footfall_per_hour = [];
				} else if(this.updated_edit_coverage_activity.add_time_by[0] == 'Category') {
					if(this.updated_edit_coverage_activity.prep_time_categories && this.updated_edit_coverage_activity.prep_time_categories.length == 0) {
						this.updated_edit_coverage_activity.prep_time_categories.push({
							department: null,
							order_type: this.updated_edit_coverage_activity.order_type ? this.updated_edit_coverage_activity.order_type : [],
							lower_threshold: 0,
							higher_threshold: 0,
							hours: 0,
							minutes: 0,
							seconds: 0,
							arr_field: [],
						});
					}
					this.updated_edit_coverage_activity.prep_time_overall = {};
					this.updated_edit_coverage_activity.prep_time_subcategories = [];
					this.updated_edit_coverage_activity.prep_time_departments = [];
					this.updated_edit_coverage_activity.transaction_per_hour = [];
					this.updated_edit_coverage_activity.quantitiy_per_hour = [];
					this.updated_edit_coverage_activity.footfall_per_hour = [];
				} else if(this.updated_edit_coverage_activity.add_time_by[0] == 'Subcategory') {
					if(this.updated_edit_coverage_activity.prep_time_subcategories && this.updated_edit_coverage_activity.prep_time_subcategories.length == 0) {
						this.updated_edit_coverage_activity.prep_time_subcategories.push({
							department: null,
							order_type: this.updated_edit_coverage_activity.order_type ? this.updated_edit_coverage_activity.order_type : [],
							lower_threshold: 0,
							higher_threshold: 0,
							hours: 0,
							minutes: 0,
							seconds: 0,
							arr_field: [],
						});
					}
					this.updated_edit_coverage_activity.prep_time_overall = {};
					this.updated_edit_coverage_activity.prep_time_categories = [];
					this.updated_edit_coverage_activity.prep_time_departments = [];
					this.updated_edit_coverage_activity.transaction_per_hour = [];
					this.updated_edit_coverage_activity.quantitiy_per_hour = [];
					this.updated_edit_coverage_activity.footfall_per_hour = [];
				} else if(this.updated_edit_coverage_activity.add_time_by[0] == 'Department') {
					if(this.updated_edit_coverage_activity.prep_time_departments && this.updated_edit_coverage_activity.prep_time_departments.length == 0) {
						this.updated_edit_coverage_activity.prep_time_departments.push({
							department: null,
							order_type: this.updated_edit_coverage_activity.order_type ? this.updated_edit_coverage_activity.order_type : [],
							lower_threshold: 0,
							higher_threshold: 0,
							hours: 0,
							minutes: 0,
							seconds: 0,
							arr_field: [],
						});
					}
					this.updated_edit_coverage_activity.prep_time_overall = {};
					this.updated_edit_coverage_activity.prep_time_categories = [];
					this.updated_edit_coverage_activity.prep_time_subcategories = [];
					this.updated_edit_coverage_activity.prep_time_departments = [];
					this.updated_edit_coverage_activity.transaction_per_hour = [];
					this.updated_edit_coverage_activity.quantitiy_per_hour = [];
					this.updated_edit_coverage_activity.footfall_per_hour = [];
				}
			}
		},
		deleteSubCategoryThreshold(subcategory_index, threshold_index) {
			if (this.sub_category_activity_list[subcategory_index].transaction_threshold[threshold_index].id) {
				var data = {
					id: this.sub_category_activity_list[subcategory_index].transaction_threshold[threshold_index].id
				};

				labourPlanningService.deleteAvgTimesSubCategory(data)
					.then(async (response) => {
						if (response.status == 204) {
							this.sub_category_activity_list[subcategory_index].transaction_threshold.splice(threshold_index, 1);

							// this.getAllStoreNonCoverageActivities();
							await this.getDailyActivities();
							await this.getNonCoverageActivities();
							await this.getCoverageActivities();
						}
					});
			} else {
				this.sub_category_activity_list[subcategory_index].transaction_threshold.splice(threshold_index, 1);
			}
		},
		async enableDisableDailyActivity(status, id) {
			const params = {
				outlet: this.outlet,
				data: [
					{
						id: id,
						enabled: status
					}
				]
			};
			await labourPlanningService.enableOrDisableDailyActivity(params)
			.then(async (response) => {
				await this.getDailyActivities();
			})
			.catch(error => console.error(error));
		},
		openEditSectionNonCoverageActivity(row) {
			let localData = row;
			if(localData && localData.enabled) {
				this.updateSectionActivity = true;
				if(localData && localData.actions.length) {
					if(localData.plan_by != 'duration') {
						for(let i = 0; i < localData.actions.length; i++) {
							if(!localData.actions[i].selected_time_units || !localData.actions[i].selected_time_units.length) {
								localData.actions[i].selected_time_units = [{
									start_time: null,
									end_time: null
								}];
							}
						}
					}
				}
				this.edit_select_non_coverage_activity = localData;
			} else {
				this.$notify.error({
					title: "Permission Denied",
					message: "You must enable the activity in order to perform an edit operation!"
				});
			}
		},
		checkIfMappedNonCoverageActivity(section, station) {
			let result = false;
			let check = this.mappedSectionsAndStations.find(el => el.id == section);
			if(check !== undefined) {
				let filterData = check.setups_for_section.find(el => el.function == station && el.non_coverage_hours_defined == true);
				if(filterData !== undefined) {
					result = true;
				}
			}
			return result;
		},
		openNonCoverageActivityByStationAndSection(section_id = null, station_id = null) {
			if(section_id && station_id) {
				if(this.groupedNonCoverageSections[section_id] && this.groupedNonCoverageSections[section_id].length) {
					let check = this.groupedNonCoverageSections[section_id].filter(el => el.function == station_id);
					if(check && check.length && check.length == 1) {
						let localData = {...check[0]};
						if(localData.actions && localData.actions.length) {
							let allDays = this.daysList.filter(el => el.value != 'all').map(el => el.value);
							for(let i = 0; i < localData.actions.length; i++) {
								if(localData.actions[i].weekly_freq && localData.actions[i].weekly_freq.length) {
									let allCheck = allDays.every(el => localData.actions[i].weekly_freq.includes(el));
									if(allCheck === true) {
										localData.actions[i].weekly_freq = ['all'];
									}
								}
							}
						}
						this.edit_select_non_coverage_activity = {...localData};
						this.updateSectionActivity = true;
					} else if(check && check.length == 0) {
						this.edit_select_non_coverage_activity = {
							// id: null,
							designation: "",
							function: station_id,
							duration: 0,
							frequency: "daily",
							hourly_freq: "0.0",
							weekly_freq: [
								"monday",
								"tuesday",
								"wednesday",
								"thursday",
								"friday",
								"saturday",
								"sunday",
							],
							monthly_freq: [],
							selected_time_units: [{ end_time: "00:00", start_time: "00:00" }],
							time_frame: "operation_hours",
							plan_by: "no_of_people",
							preferred_start_time: null,
							preferred_end_time: null,
							number_of_people: 1,
							section: section_id,
							store_section: section_id,
							activity_id: null,
							department_id: null,
							function_name: "",
							actions: [
								{
									action_id: null,
									plan_by: "no_of_people",
									hourly_freq: "0.0",
									weekly_freq: [
										"all"
									],
									monthly_freq: [],
									selected_time_units: [{ end_time: "00:00", start_time: "00:00" }],
									number_of_people: 1,
									duration: 0,
									duration_hrs: 0,
									duration_mins: 0,
									preferred_start_time: null,
									preferred_end_time: null,
								},
							],
							editable: false,
						};
						this.updateSectionActivity = true;
					} else {
						this.filtered_non_coverage_activities = [...check];
						this.show_multiple_filtered_non_coverage_activities = true;
					}
				} else {
					this.edit_select_non_coverage_activity = {
						// id: null,
						designation: "",
						function: station_id,
						duration: 0,
						frequency: "daily",
						hourly_freq: "0.0",
						weekly_freq: [
							"monday",
							"tuesday",
							"wednesday",
							"thursday",
							"friday",
							"saturday",
							"sunday",
						],
						monthly_freq: [],
						selected_time_units: [{ end_time: "00:00", start_time: "00:00" }],
						time_frame: "operation_hours",
						plan_by: "no_of_people",
						preferred_start_time: null,
						preferred_end_time: null,
						number_of_people: 1,
						section: section_id,
						store_section: section_id,
						activity_id: null,
						department_id: null,
						function_name: "",
						actions: [
							{
								action_id: null,
								plan_by: "no_of_people",
								hourly_freq: "0.0",
								weekly_freq: [
									"all"
								],
								monthly_freq: [],
								selected_time_units: [{ end_time: "00:00", start_time: "00:00" }],
								number_of_people: 1,
								duration: 0,
								duration_hrs: 0,
								duration_mins: 0,
								preferred_start_time: null,
								preferred_end_time: null,
							},
						],
						editable: false,
					};
					this.updateSectionActivity = true;
				}
			} else {
				this.edit_select_non_coverage_activity = {
					// id: null,
					designation: "",
					function: null,
					duration: 0,
					frequency: "daily",
					hourly_freq: "0.0",
					weekly_freq: [
						"monday",
						"tuesday",
						"wednesday",
						"thursday",
						"friday",
						"saturday",
						"sunday",
					],
					monthly_freq: [],
					selected_time_units: [{ end_time: "00:00", start_time: "00:00" }],
					time_frame: "operation_hours",
					plan_by: "no_of_people",
					preferred_start_time: null,
					preferred_end_time: null,
					number_of_people: 1,
					section: null,
					store_section: null,
					activity_id: null,
					department_id: null,
					function_name: "",
					actions: [
						{
							action_id: null,
							plan_by: "no_of_people",
							hourly_freq: "0.0",
							weekly_freq: [
								"monday",
								"tuesday",
								"wednesday",
								"thursday",
								"friday",
								"saturday",
								"sunday",
							],
							monthly_freq: [],
							selected_time_units: [{ end_time: "00:00", start_time: "00:00" }],
							number_of_people: 1,
							duration: 0,
							duration_hrs: 0,
							duration_mins: 0,
							preferred_start_time: null,
							preferred_end_time: null,
						},
					],
					editable: false,
				};
				this.updateSectionActivity = true;
			}
		},
		resetSelectedNonCoverageActivity() {
			this.edit_select_non_coverage_activity = {
				// id: null,
				designation: "",
				function: null,
				duration: 0,
				frequency: "daily",
				hourly_freq: "0.0",
				weekly_freq: [
					"monday",
					"tuesday",
					"wednesday",
					"thursday",
					"friday",
					"saturday",
					"sunday",
				],
				monthly_freq: [],
				selected_time_units: [{ end_time: "00:00", start_time: "00:00" }],
				time_frame: "operation_hours",
				plan_by: "no_of_people",
				preferred_start_time: null,
				preferred_end_time: null,
				number_of_people: 1,
				section: null,
				store_section: null,
				activity_id: null,
				department_id: null,
				function_name: "",
				actions: [
					{
						action_id: null,
						plan_by: "no_of_people",
						hourly_freq: "0.0",
						weekly_freq: [
							"all"
						],
						monthly_freq: [],
						selected_time_units: [{ end_time: "00:00", start_time: "00:00" }],
						number_of_people: 1,
						duration: 0,
						duration_hrs: 0,
						duration_mins: 0,
						preferred_start_time: null,
						preferred_end_time: null,
					},
				],
				editable: false,
			};
		},
		generateUUID() {
			let d = new Date().getTime();//Timestamp
			let d2 = ((typeof performance !== 'undefined') && performance.now && (performance.now()*1000)) || 0;//Time in microseconds since page-load or 0 if unsupported
			return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
				let r = Math.random() * 16;//random number between 0 and 16
				if(d > 0){//Use timestamp until depleted
					r = (d + r)%16 | 0;
					d = Math.floor(d/16);
				} else {//Use microseconds since page-load if supported
					r = (d2 + r)%16 | 0;
					d2 = Math.floor(d2/16);
				}
				return (c === 'x' ? r : (r & 0x3 | 0x8)).toString(16);
			});
		},
		generateMins(till){
			const arr = [];
			for (let min = 1; min < till; min++) {
				 arr.push(min);
			}
			return arr;
		},
		durationChanged(action_index) {
			let activity = {...this.edit_select_non_coverage_activity};
			// Calculate into mins and set to duration
			let selected_action = activity.actions[action_index];
			selected_action.duration = (selected_action.duration_hrs ? (selected_action.duration_hrs * 60) : 0) + (selected_action.duration_mins ? selected_action.duration_mins : 0);
			activity.actions[action_index] = selected_action;
			this.edit_select_non_coverage_activity = {...activity};
		},
		async deleteTimeSlot(timeSlotIndex) {
			let localBackupObj = {...this.edit_select_non_coverage_activity};
			let closeModal = localBackupObj.actions.length == 1 ? true : false;
			if(this.edit_select_non_coverage_activity.actions[timeSlotIndex].action_id) {
				await this.deleteDailyActivity(this.edit_select_non_coverage_activity.actions[timeSlotIndex].action_id);
				if(closeModal) {
					this.updateSectionActivity = false;
					this.edit_select_non_coverage_activity = {};
				}
			} else {
				this.$delete(this.edit_select_non_coverage_activity.actions, timeSlotIndex);
			}
		},
		async deleteDailyActivity(id) {
			if (id) {
				await this.$confirm(`Do you wish to delete this daily activity?`, "Alert!", {
					confirmButtonText: "Confirm",
					cancelButtonText: "Cancel",
				})
				.then(async () => {
					let obj = [{
						id: id
					}];

					await labourPlanningService.deleteDailyActivities(obj)
						.then(async (response) => {
							await this.getDailyActivities();
							let findIndex = this.dailyActivityList.findIndex((el) => el.activity_id == this.edit_select_non_coverage_activity.activity_id);
							if(findIndex !== -1) {
								this.edit_select_non_coverage_activity = {...this.dailyActivityList[findIndex]};
							}
							// await this.getAllStoreNonCoverageActivities();
							this.$notify.success({
								title: "Success",
								message: "Activity deleted Successfully"
							});
						})
						.catch(err => {
							console.error(err);
						});
				}).catch(err => {});

			}
		},
		addNewTimeSlot(actionIndex) {
			this.edit_select_non_coverage_activity.actions[actionIndex].selected_time_units.push({
				start_time: null,
				end_time: null,
			});
		},
		addNewRowTime() {
			this.edit_select_non_coverage_activity.actions.push(
				{
					"hourly_freq":"0.0",
					"weekly_freq":[],
					"selected_time_units":[{
						"start_time": null,
						"end_time": null
					}],
					"number_of_people": null,
					"duration":0,
					"preferred_start_time":null,
					"preferred_end_time":null
				}
			);
		},
		changePlanBy(value) {
			this.edit_select_non_coverage_activity.plan_by = value;
			for(let i = 0; i < this.edit_select_non_coverage_activity.actions.length; i++) {
				this.edit_select_non_coverage_activity.actions[i].plan_by = value;
			}
		},
		reformatDailyActivitiesData() {
			let tempDailyActivities = [...this.dailyActivityList];
			if(this.section_function_data.id) {
				let dailyIndex = tempDailyActivities.findIndex((el) => el.id === this.section_function_data.id);
				if(dailyIndex !== -1) {
					tempDailyActivities[dailyIndex] = {...this.section_function_data};
				} else {
					tempDailyActivities.push({...this.section_function_data});
				}
			} else {
				tempDailyActivities.push({...this.section_function_data});
			}
			let data = [...tempDailyActivities];

			let default_data = {
				store: this.outlet,
				data: []
			};
			for(let i = 0; i < data.length; i++) {
				let local_data = {...data[i]};
				if(local_data.actions && local_data.actions.length) {
					let local_actions = [...local_data.actions];
					for(let j = 0; j < local_actions.length; j++) {
						let single_action = local_actions[j];
						if(
							(local_data.plan_by == 'duration' || (single_action.number_of_people && local_data.plan_by == 'no_of_people'))
							&&
							local_data.activity_id
							// &&
							// local_data.department_id
							&&
							single_action.action_id
							&&
							local_data.plan_by
							&&
							local_data.frequency
							&&
							single_action.weekly_freq.length
						) {
							let tempObj = {
								id: local_data.action_id,
								department_id: local_data.department_id,
								function: local_data.function,
								activity_id: local_data.activity_id,
								enabled: local_data.enabled,
								duration: single_action.duration,
								frequency: local_data.frequency,
								hourly_freq: single_action.hourly_freq,
								weekly_freq: single_action.weekly_freq,
								monthly_freq: local_data.monthly_freq,
								plan_by: local_data.plan_by,
								designation_id: local_data.designation
									? local_data.designation
									: null,
								selected_time_units: single_action.selected_time_units.filter(
									(el) => el.start_time && el.end_time
								),
								number_of_people: single_action.number_of_people,
								time_frame: local_data.time_frame,
								preferred_start_time: null,
								preferred_end_time: null,
								store_section: local_data.section ? Number(local_data.section) : local_data.store_section
							};
							if(single_action.action_id) {
								tempObj.id = single_action.action_id;
							}
							default_data.data.push(tempObj);
						} else if(local_data.function && local_data.store_section) {
							// New non-coverage activity added here
							let tempObj = {
								department_id: local_data.department_id,
								function: local_data.function,
								activity_id: local_data.activity_id,
								enabled: local_data.enabled,
								duration: single_action.duration,
								frequency: local_data.frequency,
								hourly_freq: single_action.hourly_freq,
								weekly_freq: single_action.weekly_freq,
								monthly_freq: local_data.monthly_freq,
								plan_by: local_data.plan_by,
								designation_id: local_data.designation
									? local_data.designation
									: null,
								selected_time_units: single_action.selected_time_units.filter(
									(el) => el.start_time && el.end_time
								),
								number_of_people: single_action.number_of_people,
								time_frame: local_data.time_frame,
								preferred_start_time: null,
								preferred_end_time: null,
								store_section: local_data.section ? Number(local_data.section) : local_data.store_section
							};
							default_data.data.push(tempObj);
						}
					}
				}
			}
			if(default_data.data.length) {
				this.answered_activity_data = {...default_data};
			}
		},
		openStoreSettingsNonCoverageActivityModal(activity_details) {
			let localData = {...activity_details};
			if(localData.actions && localData.actions.length) {
				let allDays = this.daysList.filter(el => el.value != 'all').map(el => el.value);
				for(let i = 0; i < localData.actions.length; i++) {
					if(localData.actions[i].weekly_freq && localData.actions[i].weekly_freq.length) {
						let allCheck = allDays.every(el => localData.actions[i].weekly_freq.includes(el));
						if(allCheck === true) {
							localData.actions[i].weekly_freq = ['all'];
						}
					}
				}
			}

			this.edit_select_non_coverage_activity = {...localData};
			this.updateSectionActivity = true;
		},
		validateNonCoverageEditActivity() {
			let response = true;
			let local_non_coverage_activity_details = {...this.edit_select_non_coverage_activity};
			if(!local_non_coverage_activity_details.frequency) {
				response = false;
			}
			if(response) {
				for(let i = 0; i < local_non_coverage_activity_details.actions.length; i++) {
					if(local_non_coverage_activity_details.frequency == 'monthly') {
						let monthly_freq = [...local_non_coverage_activity_details.actions[i].monthly_freq];
						if(!monthly_freq || !monthly_freq.length) {
							response = false;
							break;
						}
					} else if(local_non_coverage_activity_details.frequency != 'daily') {
						let weekly_freq = [...local_non_coverage_activity_details.actions[i].weekly_freq];
						if(!weekly_freq || !weekly_freq.length) {
							response = false;
							break;
						}
					}
					
					let selected_time_units = [...local_non_coverage_activity_details.actions[i].selected_time_units];
					if(response) {
						for(let j = 0; j < selected_time_units.length; j++) {
							let time_obj = {...selected_time_units[j]};
							if(!time_obj.start_time || !time_obj.end_time) {
								response = false;
								break;
							}
						}
					}
					if(!local_non_coverage_activity_details.actions[i].plan_by) {
						response = false;
					} if(local_non_coverage_activity_details.actions[i].plan_by) {
						if(local_non_coverage_activity_details.actions[i].plan_by == 'duration') {
							if(!local_non_coverage_activity_details.actions[i].duration_hrs && !local_non_coverage_activity_details.actions[i].duration_mins) {
								response = false;
								break;
							}
						} else if(local_non_coverage_activity_details.actions[i].plan_by == 'no_of_people') {
							if(!local_non_coverage_activity_details.actions[i].number_of_people) {
								response = false;
								break;
							}
						}
					}
					if(!response) {
						break;
					}
				}
			}
			return response;
		},
		async saveDailyActivities() {
			let validationResponse = this.validateNonCoverageEditActivity();
			EventBus.$emit('nonCoverageActivityValidated', validationResponse);
			if(validationResponse === true) {
				let local_non_coverage_activity_details = {...this.edit_select_non_coverage_activity};
				if(local_non_coverage_activity_details.actions && local_non_coverage_activity_details.actions.length) {
					for(let i = 0; i < local_non_coverage_activity_details.actions.length; i++) {
						if(local_non_coverage_activity_details.actions[i].weekly_freq.includes('all')) {
							local_non_coverage_activity_details.actions[i].weekly_freq = this.daysList.filter(el => el.value != 'all').map(el => el.value);
						}
					}
				}
				let findIndexVal = this.dailyActivityList.findIndex((el) => el.activity_id == local_non_coverage_activity_details.activity_id);
				if(findIndexVal !== -1) {
					this.dailyActivityList[findIndexVal] = {...local_non_coverage_activity_details};
				} else {
					this.dailyActivityList.push({...local_non_coverage_activity_details});
				}
				this.reformatDailyActivitiesData();
				if(this.answered_activity_data.store && this.answered_activity_data.data.length) {
					labourPlanningService.addOrUpdateDailyActivities(this.answered_activity_data)
					.then(async (response) => {
						this.showNonCoverageActivity = false;
						this.updateSectionActivity = false;
						this.$notify.success({
							title: "Success",
							message: "Daily activities updated",
							type: "success"
						});
						this.section_function_data = {};
						this.updateSectionActivity = false;
						this.resetSelectedNonCoverageActivity();
						await this.getDailyActivities();
					}).catch(error => {
						console.error(error);
						this.$notify.error({
							title: "Failed",
							message: "Unable to process daily activity",
							type: "error"
						});
					});
				}
			}
		},
		deleteNonCoverageActivity(non_coverage_activity) {
			if(non_coverage_activity && non_coverage_activity.id && non_coverage_activity.actions && non_coverage_activity.actions.length) {
				let idArr = non_coverage_activity.actions.map((el) => ({id: el.action_id}));
				if(idArr.length) {
					this.$confirm(`Do you wish to delete this daily activity?`, "Alert!", {
						confirmButtonText: "Yes",
						cancelButtonText: "No",
						type: "warning",
						cancelButtonClass: "bg-success",
						confirmButtonClass: "bg-warning"
					})
					.then(() => {
						labourPlanningService.deleteDailyActivities(idArr)
							.then(async (response) => {
								await this.getDailyActivities();
								this.$notify.success({
									title: "Success",
									message: "Activity deleted succesfully"
								});
							})
							.catch(err => {
								console.error(err);
							});
					}).catch(err => {});
				}
			}
		},
		showStoreSectionEditModal(obj) {
			this.store_section_details = {...obj};
			// this.$sidebarModal.show('store-section-edit-modal');
			this.show_store_section_modal = true;
		},
		hideStoreSectionEditModal() {
			this.show_store_section_modal = false;
			// this.$sidebarModal.hide('store-section-edit-modal');
			this.store_section_details = {};
		},
		saveStoreSectionDetails() {
			if(this.store_section_details.id) {
				let index = this.sections.findIndex((el) => el.id === this.store_section_details.id);
				if(index !== -1) {
					if(this.store_section_details.activities) {
						this.$delete(this.store_section_details, 'activities');
					}
					this.sections[index] = {...this.store_section_details};
					const params = {
						store: this.outlet,
						data: [...this.sections]
					};
					labourPlanningService
						.addOrUpdateSectionFunction(params)
						.then(async (res) => {
							await this.getSections();
							this.hideStoreSectionEditModal();
						})
						.catch((err) => {
							console.error(err);
						})
				}
			}
		},
		editCombinedNonCoverageActivity(activity_details) {
			this.non_coverage_activity_details = {...activity_details};
			this.hide_show_non_coverage_activity = true;
		},
		closeCombinedNonCoverageActivity() {
			this.hide_show_non_coverage_activity = false;
			this.non_coverage_activity_details = {};
		},
		mapStationWithFunction() {
			let data = {...this.section_function_data};
			let listData = [...this.mappedSectionsAndStations];
			let findKey = listData.findIndex(el => el.id === data.id);
			listData[findKey] = {...data};
			this.showNonCoverageActivity = false;
			for(let i = 0; i < listData.length; i++) {
				for(let j = 0; j < listData[i].setups_for_section.length; j++) {
					if(listData[i].id == data.id) {
						listData[i].setups_for_section[j].non_coverage_hours_defined = true;
					}
				}
			}
			this.mappedSectionsAndStations = [...listData];
			const params = {
				store: this.outlet,
				data: [...this.sections]
			};
			labourPlanningService
				.addOrUpdateSectionFunction(params)
				.then(async (res) => {
					if(data && data.activities && data.activities.length) {
						const payloadData = [
							{
								function: data.mapped_functions[0],
								section: data.id,
								activities: [...data.activities],
								time_frame: data.time_frame ? data.time_frame : null,
							}
						];
						this.saveNonCoverageDailyActivities(payloadData);
					}
				})
				.catch((err) => {
					console.error(err);
				})
				.finally(res => {
					this.section_function_data = {
						id: null,
						store: this.outlet,
						base_section: 0,
						department: null,
						name: "",
						applicable_functions: [],
						enabled: true,
						transaction_threshold: 0,
						section_open_time: "00:00:00",
						section_close_time: "00:00:00",
						setups_for_section: [],
						activities: []
					};
				});
		},
		openSectionalCoverageActivity(station_id, section_id) {
			let check = this.updated_format_coverage_activities.filter(el => el.section_id == section_id);
			if(check.length) {
				if(check.length == 1) {
					let checkStation = check[0].section_setup.filter((el, index) => el.station_id == station_id);
					if(checkStation.length) {
						if(checkStation.length == 1) {
							let checkStationIndex = check[0].section_setup.findIndex(el => el.station_id == station_id);
							this.editUpdatedCoverageActivity(section_id, checkStationIndex);
						} else {
							this.grouped_store_setting_coverage_activities = check[0].section_setup
							.map((el, index) => ({
								...el,
								unique_index: index,
							}))
							.filter((el) => el.station_id == station_id);
							this.hide_show_coverage_grouped_coverage_activity_modal = true;
							this.$forceUpdate();
							console.log('station_id', station_id)
						}
					} else {
						this.updated_edit_coverage_activity = {
							index_val: -1,
							section_id: section_id,
							station_id: station_id,
							station_name: this.getFunctionName(station_id),
							add_time_by: [],
							quantitiy_per_hour: [],
							coverage_activity_enabled: true,
							"non-coverage_activity_enabled": false,
							planning_criteria: null,
							daily_activity: [],
							prep_time_categories: [],
							prep_time_subcategories: [],
							prep_time_departments: [],
							prep_time_overall: {
								hours: 0,
								minutes: 0,
								seconds: 0,
								store_id: this.outlet,
								department_id: null,
								function_id: station_id,
								order_type: this.updated_edit_coverage_activity.order_type ? this.updated_edit_coverage_activity.order_type : [],
							},
							transaction_linked_activites: [],
							transaction_per_hour: [],
							footfall_per_hour: [],
						};
						this.hide_show_new_coverage_activity = true;
					}
				}
			} else {
				this.updated_edit_coverage_activity = {
					index_val: -1,
					section_id: section_id,
					station_id: station_id,
					station_name: this.getFunctionName(station_id),
					add_time_by: [],
					quantitiy_per_hour: [],
					coverage_activity_enabled: true,
					"non-coverage_activity_enabled": false,
					planning_criteria: null,
					daily_activity: [],
					prep_time_categories: [],
					prep_time_subcategories: [],
					prep_time_departments: [],
					prep_time_overall: {
						hours: 0,
						minutes: 0,
						seconds: 0,
						store_id: this.outlet,
						department_id: null,
						function_id: station_id,
						order_type: this.updated_edit_coverage_activity.order_type ? this.updated_edit_coverage_activity.order_type : [],
					},
					transaction_linked_activites: [],
					transaction_per_hour: [],
					footfall_per_hour: [],
				};
				this.hide_show_new_coverage_activity = true;
			}
		},
		openSectionalNonCoverageActivity(station_id) {
			// code goes here...
		},
		resetCoverageActivityModalData() {
			this.selected_section = "";
			this.selected_functions = "";
			this.planning_type = "";
			this.order_type = "";
			this.addTime = null;
			this.planning_level = "category";
			this.selectedCategories = [];
			this.selected_sub_categories = [];
			this.select_planning_level_department = [];
			this.numTeancList = [
				{
					function: "",
					basis: "",
					range_start: 0,
					range_end: 0,
					start: (min = 0, max = 1000, step = 1) => {
						let arr = [];
						for (let i = min; i <= max; i += step) {
							arr.push(i);
						}
						return arr;
					},
					end: (min = 0, max = 1000, step = 1) => {
						let arr = [];
						for (let i = min; i <= max; i += step) {
							arr.push(i);
						}
						return arr;
					},
					range_requirement: 0,
				}
			];
			this.overall_average = { hours: 0, minutes: 0, seconds: 0 };
			this.avgTimePerCategory = [
				{
					id: "",
					function: "",
					department: "",
					category: [],
					subcategory: [],
					transaction_threshold: [],
					higher_threshold: 0,
					lower_threshold: 0,
					hours: "",
					minutes: "",
					seconds: "",
					order_type : []
				},
			];
			this.sub_category_activity_list = [
				{
					id: "",
					function: "",
					department: "",
					category: "",
					subcategory: [],
					transaction_threshold: [],
					higher_threshold: 0,
					lower_threshold: 0,
					hours: "",
					minutes: "",
					seconds: "",
					order_type : []
				},
			];
			this.department_activities = [
				{
					id: "",
					function: "",
					department: "",
					product_department: "",
					category: "",
					hours: "",
					minutes: "",
					seconds: "",
					order_type : []
				},
			];
			this.transactionActivities = [
				{
					id: "",
					function: "",
					department: "",
					name: "",
					hours: "",
					minutes: "",
					seconds: "",
					order_type : []
				},
			];
		},
		async removeSectionStationMapping() {
			if(this.store_settings_non_coverage_activity_ids && this.store_settings_non_coverage_activity_ids.length) {
				const payload = {
					store: this.outlet,
					ids: this.store_settings_non_coverage_activity_ids
				};
				await labourPlanningService.deleteSectionStationMapping(payload)
				.then(response => {
					this.getSections();
				})
				.catch(error => {
					console.error(error);
				})
				.finally(res => {
					this.store_settings_non_coverage_activity_ids = [];
				});
			}
		},
		activityAlreadyInUse(section, station, activity) {
			let result = false;
			let check = this.dailyActivityList.find(el => el.store_section == section && el.function == station && el.activity_id == activity);
			if(check !== undefined) {
				result = true;
			}
			return result;
		},
		openEditNonCoverageCompanyActivity(section, station) {
			this.section_function_data = {...section, mapped_functions: [station]};
			this.showNonCoverageActivity = true;
		},
		deleteSectionStationMappingRow(item) {
			this.$confirm(`Are you sure want to delete this section?`, 'Alert!', {
				confirmButtonText: 'Confirm',
				dangerouslyUseHTMLString: true
			}).then(async () => {
				this.store_settings_non_coverage_activity_ids = [item.id];
				let deleteDailyActivityIds = [];
				let station_id = item.function;
				let section_id = item.store_section;
				let daily_activities = this.dailyActivityList.filter(el => el.store_section == section_id && el.function == station_id);
				for(let i = 0; i < daily_activities.length; i++) {
					deleteDailyActivityIds = [...deleteDailyActivityIds, ...daily_activities[i].actions.map(el => ({id: el.action_id}))];
				}
				if(deleteDailyActivityIds.length) {
					await this.bulkDeleteDailyActivities(deleteDailyActivityIds);
				}
				await this.removeSectionStationMapping();
				await this.getDailyActivities();
			})
			.catch(error => console.error(error));
		},
		selectNonCoverageStationsForDeletion(event) {
			let localVal = this.mappedSectionsAndStations.find(el => el.id == this.section_function_data.id).setups_for_section.map(el => el);
			let section_setup_id = localVal.find(el => el.function == event);
			if(section_setup_id) {
				let check = this.store_settings_non_coverage_activity_ids.find(el => el == section_setup_id.id);
				if(check === undefined) {
					this.store_settings_non_coverage_activity_ids.push(section_setup_id.id);
				}
			}
		},
		unselectTagHandlerNonCoverageStation(upcomingVal) {
			if(upcomingVal.includes('add_new')) {
				this.selected_functions = "";
				this.station_details = {
					title: ""
				};
				this.hide_show_station_add_edit_popup = true;
				this.section_function_data.mapped_functions = upcomingVal.filter(el => el != 'add_new');
			}
			/* let event = upcomingVal.filter(el => el != 'add_new');
			let localVal = this.mappedSectionsAndStations.find(el => el.id == this.section_function_data.id).setups_for_section.map(el => el);
			let deleteVal = localVal.filter(el => !event.includes(el.function)).map(el => el.id);
			const onlyUnique = (value, index, array) => {
				return array.indexOf(value) === index;
			}
			this.store_settings_non_coverage_activity_ids = [...this.store_settings_non_coverage_activity_ids, ...deleteVal].filter(onlyUnique); */
		},
		handleChangeNewActivityAddPopup(event) {
			if(event.includes('add_new')) {
				this.section_function_data.activities = event.filter(el => el != 'add_new');
				this.openAddAcitivityDialog();
			}
		},
		copyCompanySettings(command) {
			const payload = {
				outlet: 'all',
				to_copy: command
			};
			labourPlanningService.copyAllCompanySettings(payload)
			.then(res => {
				this.$notify.success({
					title: "Success",
					message: `Successfully copied ${command} to all stores`
				});
			})
			.catch(error => console.error(error));
		},
		async getAllStoreNonCoverageActivities() {
			if(this.outlet || this.head_office_id) {
				const id = this.$route.name === "Company" ? (this.head_office_id ? this.head_office_id : localStorage.getItem('head_office_id')) : this.outlet;
				await labourPlanningService.getActivitesTypeList({outlet_id: id})
				.then(response => {
					let responseData = JSON.parse(response.data);
					responseData.sort((a, b) => a.name.toLowerCase() - b.name.toLowerCase());
					this.activity_type_list = responseData;
					this.groupSectionalFunctionalActivities();
				})
				.catch(error => console.error(error));
			}
		},
		async saveNonCoverageDailyActivities(params) {
			const self = this;
			const payload = {
				store: this.outlet,
				data: params
			};
			await labourPlanningService.saveUpdateNonCoverageDailyActivities(payload)
			.then(response => {
				// const responseData = JSON.parse(response.data);
			})
			.catch(error => console.error(error))
			.finally(async (result) => {
				// await self.removeSectionStationMapping();
				await self.getSections();
				await self.getDailyActivities();
				await self.getNonCoverageActivities();
			});
		},
		getActivityName(activity_type_id) {
			if(this.activity_type_list && this.activity_type_list.length) {
				const checkData = this.activity_type_list.find(el => el.id == activity_type_id);
				if(checkData && checkData.name) {
					return checkData.name;
				} else {
					return '-';
				}
			} else {
				return '-';
			}
		},
		handleActivityType() {
			this.selected_activity = {};

			// filter selected activity from activities list
			let filtered_activity_type = this.activity_type_list.filter(e => {
				return e.id == this.activity_name;
			});

			if (filtered_activity_type.length) {
				this.activity_name = filtered_activity_type[0].name;

				setTimeout(() => {
					let obj = {
						activity: filtered_activity_type[0].id,
						activity_info: {
							name: filtered_activity_type[0].name,
							id: filtered_activity_type[0].id,
							store_types: filtered_activity_type[0].store_types ? (filtered_activity_type[0].store_types).slice(0) : []		//get shadow copy of store types
						}

					}
					this.selected_activity = obj;		//selected activity info

					if (this.selected_activity.activity_info && this.selected_activity.activity_info.store_types.length) {
						for (let i = 0; i < this.selected_activity.activity_info.store_types.length; i++) {
							if (this.selected_activity.activity_info.store_types[i] == 'all_store_type') {
								this.all_store_type = true;
							} else if (this.selected_activity.activity_info.store_types[i] == 'dine_in') {
								this.dine_in = true;
							} else if (this.selected_activity.activity_info.store_types[i] == 'restroom') {
								this.restroom = true;
							} else if (this.selected_activity.activity_info.store_types[i] == 'drive_through') {
								this.drive_through = true;
							} else if (this.selected_activity.activity_info.store_types[i] == 'delivery') {
								this.delivery = true;
							}
						}
					}
				}, 200);
			} else {  // if not in filtered activity then considered it is as a new activity
				this.selected_activity = {};
				this.all_store_type = false;
				this.dine_in = false;
				this.restroom = false;
				this.drive_through = false;
				this.delivery = false;
			}


		},
		openAddAcitivityDialog() {
			this.clearAddActivityDialogInputs();			//function to clear dialog inputs
			this.activity_dialog_visible = true;
		},

		// function called from add activity dialog
		saveActivityType() {
			if (Object.keys(this.selected_activity).length) {
				this.updateActivityTypeNetWorkCallBack();
			} else {
				this.addActivityType();
			}
		},
		// api to add new activity type
		async addActivityType() {
			let activity_name = this.activity_name && this.activity_name ? ((this.activity_name).trim()).toLowerCase() : '';

			let is_activity_already_exist = false;

			for (let i = 0; i < this.activity_type_list.length; i++) {
				if (((this.activity_type_list[i].name).trim()).toLowerCase() == activity_name) {
					is_activity_already_exist = true;

					this.$message({
						showClose: true,
						message: 'Acitvity already exist.',
						type: 'error'
					});

					break;
				}
			}

			if (!is_activity_already_exist) {
				this.is_add_activity_in_progress = true;	//enabled loader on btn

				let selected_store_types = [this.all_store_type ? 'all_store_type' : this.dine_in ? 'dine_in' : '', this.restroom ? 'restroom' : '', this.drive_through ? 'drive_through' : '', this.delivery ? 'delivery' : '']

				let params = {
					name: this.activity_name,
					store_types: []
				}

				params.store_types = selected_store_types.filter(item => item);			//removed undefined, null, ''

				labourPlanningService.addActivityType(params, Object.keys(this.selected_activity).length ? 'UPDATE' : 'NEW_ADD', this.selected_activity.activity)
					.then(async (response) => {
						if (response.status == 201) {
							await this.getAllStoreNonCoverageActivities();

							this.$notify.success({
								title: "Success",
								message: "Activity added Succesfully"
							});

							this.is_add_activity_in_progress = false;	//disabled loader on btn

							this.activity_dialog_visible = false;
						} else {
							this.$notify.error({
								title: "Error",
								message: "Failed to add Activity"
							});

							this.is_add_activity_in_progress = false;	//disabled loader on btn
						}
					})
					.catch(err => {
						console.error(err);
						this.$notify.error({
							title: "Error",
							message: "Failed to add Activity"
						});
						this.is_add_activity_in_progress = false;	//disabled loader on btn
					});
			}

		},

		// api to update activity type
		async updateActivityTypeNetWorkCallBack() {
			let activity_name = this.activity_name ? ((this.activity_name).trim()).toLowerCase() : '';

			let is_activity_already_exist = false;

			for (let i = 0; i < this.activity_type_list.length; i++) {
				// if entered activity name is not equal to exited activity name and also not exqual to selected activity
				if (((this.activity_type_list[i].name).trim()).toLowerCase() == activity_name && activity_name != ((this.selected_activity.activity_info.name).trim()).toLowerCase()) {
					is_activity_already_exist = true;

					this.$message({
						showClose: true,
						message: 'Acitvity already exist.',
						type: 'error'
					});

					break;
				}
			}

			if (!is_activity_already_exist) {
				this.is_add_activity_in_progress = true;	//enabled loader on btn

				let selected_store_types = [this.all_store_type ? 'all_store_type' : this.dine_in ? 'dine_in' : '', this.restroom ? 'restroom' : '', this.drive_through ? 'drive_through' : '', this.delivery ? 'delivery' : '']

				let params = {
					id: this.selected_activity.activity,
					name: this.activity_name,
					store_types: []
				}

				params.store_types = selected_store_types.filter(item => item);			//removed undefined, null, ''

				labourPlanningService.updateActivityType(params)
					.then(async (response) => {
						if (response.status == 200) {
							await this.getAllStoreNonCoverageActivities();

							this.$notify.success({
								title: "Success",
								message: "Activity updated Succesfully"
							});

							this.is_add_activity_in_progress = false;	//disabled loader on btn

							this.activity_dialog_visible = false;
						} else {
							this.$notify.error({
								title: "Error",
								message: "Failed to update Activity"
							});

							this.is_add_activity_in_progress = false;	//disabled loader on btn
						}
					})
					.catch(err => {
						console.error(err);
						this.$notify.error({
							title: "Error",
							message: "Failed to update Activity"
						});
						this.is_add_activity_in_progress = false;	//disabled loader on btn
					});
			}
		},
		clearAddActivityDialogInputs() {
			this.activity_name = '';
			this.all_store_type = false;
			this.dine_in = false;
			this.restroom = false;
			this.drive_through = false;
			this.delivery = false;
			this.selected_activity = {};
		},
		setAllStoreType() {
			if (this.all_store_type) {
				this.dine_in = false;
				this.restroom = false;
				this.drive_through = false;
				this.delivery = false;
			}
		},
		setActivityType() {
			if (this.all_store_type) {
				this.this.all_store_type = false;
			}
		},
		// api to delete activity type
		deleteAcitivityType() {
			if (this.selected_activity.activity) {
				this.is_daily_activites_loading = true;		//enabled loader

				let obj = {
					id: this.selected_activity.activity
				};

				labourPlanningService.deleteActivityType(obj)
					.then(async (response) => {
						this.activity_dialog_visible = false;

						await this.getAllStoreNonCoverageActivities();

						this.$notify.success({
							title: "Success",
							message: "Activity type deleted Successfully"
						});

						this.is_daily_activites_loading = false;		//disabled loader

					})
					.catch(err => {
						console.error(err);
						this.is_daily_activites_loading = false;		//disabled loader
					});
			}
		},
		toggleNonCoverageStation(section_id, station_id) {
			let sectionDataIndex = this.mappedSectionsAndStations.findIndex(el => el.id == section_id);
			if(sectionDataIndex !== -1) {
				let stationDataIndex = this.mappedSectionsAndStations[sectionDataIndex].setups_for_section.findIndex(el => el.function == station_id && el.non_coverage_hours_defined);
				if(stationDataIndex !== -1) {
					let dataValue = this.mappedSectionsAndStations[sectionDataIndex].setups_for_section[stationDataIndex].enabled;
					this.mappedSectionsAndStations[sectionDataIndex].setups_for_section[stationDataIndex].enabled = !dataValue;
					this.addOrUpdateSection();
				}
			}
		},
		async triggerLabourHourForecast() {
			this.store_details_processing = true;
			let weekToDate = this.calculateWeekToDate();
			let fromDate = moment(new Date()).format('YYYY-MM-DD');
			// Set week days
			// Set the week start day as Monday
			moment.updateLocale('en', {
				week: {
				dow: 1, // Monday
				},
			});
			
			// Get the start and end dates of the next week
			const today = moment();
			const startOfNextWeek = today.clone().add(1, 'week').startOf('week');
			const endOfNextWeek = today.clone().add(1, 'week').endOf('week');
			
			// Format the dates as desired
			const startDateNextWeek = startOfNextWeek.format('YYYY-MM-DD');
			const endDateNextWeek = endOfNextWeek.format('YYYY-MM-DD');
			// console.log(startDateNextWeek, endDateNextWeek, 'endDateendDate');
			// Set week days
			const params = {
				from_date: fromDate,
				outlet: this.outlet,
				adt_forecast: true,
				hourly_ipt_forecast: true,
				labour_forecast: true,
				ticket_size_forecast: true,
				start_date: startDateNextWeek,
				end_date: endDateNextWeek
			};
			await labourPlanningService.triggerLabourPlanningForecast(params)
			.then(response => {
				// console.warn(response.data);
				this.store_details_processing = false;
				this.store_processing_completed = true;
				// Polling process status
				if(this.checkCompany.is_mcd_north){
					// this.getProcessStatus(this.selectedOutlet);
				}
				setTimeout(() => {
					this.store_processing_completed = false;
				}, 9000);
			})
			.catch(error => {
				console.error(error);
				this.store_details_processing = false;
			});
		},
		getProcessStatus(){
			console.log('0');
			let selectedStore = this.selectedOutlet;
			labourPlanningService.getProcessStatus().then((res)=>{
				const processStatus = JSON.parse(res.data);
				this.$store.commit("CommonStore/setProcessStatus", processStatus);
				if(!processStatus.allow_forecast || !processStatus.allow_autoschedule){
					this.startProcessStatusPolling(this.selectStore);
					console.log('1')
				} else if(!processStatus.allow_autoschedule) {
					this.startProcessStatusPolling(this.selectStore);
					console.log('2')
				}
			}).catch((err)=>{
				console.error(err);
			});
		},
		calculateWeekToDate() {
			let date = new Date();
			let nextWeekStart = date.getDate() - date.getDay() + 8;
			let nextWeekFrom = new Date(date.setDate(nextWeekStart));
			let nextWeekEnd = date.getDate() - date.getDay() + 7;
			let nextWeekTo = new Date(date.setDate(nextWeekEnd));
			let result = {
				start_date: moment(nextWeekFrom).format('YYYY-MM-DD'),
				end_date: moment(nextWeekTo).format('YYYY-MM-DD')
			};
			return result;
		},
		toggleStoreDetailsSavePopup() {
			this.show_store_details_save_confirmation = !this.show_store_details_save_confirmation;
			console.log();
		},
		async saveStoreDetailsData() {
			EventBus.$emit('saveStoreDetails', true);
			await this.addOrUpdateSection();
			if(this.store_details_save_choice === '1') {
				setTimeout(async () => {
					await this.triggerLabourHourForecast();
				}, 1000);
			}
			this.toggleStoreDetailsSavePopup();
		},
		async getNonCoverageActivitiesHourlyData() {
			// Here we are calling updated API
			console.log(this.outlet ,'this.outlet')
			await labourPlanningService.getFixedActivitySummary(this.outlet)
			.then(response => {
				this.non_coverage_activity_hourly_view = JSON.parse(response.data);
				console.log(JSON.parse(response.data), 'Updated activity data')
			})
			.catch(error => {
				console.error(error);
			});
		},
		getAllTotalByAcHr(elm){
			// console.log(elm, 'elm');
			let activity_sum = 0;
			let time_sum = 0;
			for (const key in elm.activitywise_sum) {
				if (Object.hasOwnProperty.call(elm.activitywise_sum, key)) {
					const activity_data = elm.activitywise_sum[key];
					activity_sum += activity_data.sum;
				}
			}
			// for (const key in elm.timewise_sum) {
			// 	if (Object.hasOwnProperty.call(elm.timewise_sum, key)) {
			// 		const time_data = elm.timewise_sum[key];
			// 		// console.log(time_data, 'time_data');
			// 		time_sum += time_data;
			// 	}
			// }
			// console.log(activity_sum,time_sum, 'activity_sum')
			return (activity_sum).toFixed(2);
		},
		async getDailyActivitiesSummary() {
			const params = [
				{
					"store_id": this.outlet,
					"activity_id": null,
					"day": "monday",
					"timewise_sum": false
				},
				{
					"store_id": this.outlet,
					"activity_id": null,
					"day": "tuesday",
					"timewise_sum": true
				},
				{
					"store_id": this.outlet,
					"activity_id": null,
					"day": "wednesday",
					"timewise_sum": false
				},
				{
					"store_id": this.outlet,
					"activity_id": null,
					"day": "thursday",
					"timewise_sum": true
				},
				{
					"store_id": this.outlet,
					"activity_id": null,
					"day": "friday",
					"timewise_sum": true
				},
				{
					"store_id": this.outlet,
					"activity_id": null,
					"day": "saturday",
					"timewise_sum": true
				},
				{
					"store_id": this.outlet,
					"activity_id": null,
					"day": "sunday",
					"timewise_sum": true
				},
			];
			await labourPlanningService.getDailyActivitiesUpdatedSummary(params)
			.then(response => {
				let responseData = JSON.parse(response.data);
				this.non_coverage_activity_hourly_view_summary = responseData;
			})
			.catch(error => {
				console.error(error);
			});
		},
		async openHourlyView() {
			if(this.outlet) {
				await this.getNonCoverageActivitiesHourlyData();
				await this.getDailyActivitiesSummary();
				// called staff info data
				if(!Object.keys(this.staffDetails).length){
					await this.getStaffDetails();
				}
				this.hide_show_non_coverage_activity = true;
			}
		},
		calculateTimeWiseData(time_slot_and_function) {
			let total = {};
			
			for (const key in time_slot_and_function) {
			  const time_slots = time_slot_and_function[key];
			  for (const time_slot in time_slots) {
				  if (total[time_slot]) {
				  total[time_slot] += parseInt(time_slots[time_slot]);
				} else {
				  total[time_slot] = parseInt(time_slots[time_slot]);
				}
			  }
			}
			return total;
		},
		async updateHourlyView() {
			let params = [];
			for(let i = 0; i < this.non_coverage_activity_hourly_view.length; i++) {
				const payload = {
					store: this.outlet
				};
				payload.day = this.non_coverage_activity_hourly_view[i].day;
				payload.data = this.non_coverage_activity_hourly_view[i].time_slot_and_function ? {...this.non_coverage_activity_hourly_view[i].time_slot_and_function} : {}
				for(let prop in payload.data) {
					for(let prop1 in payload.data[prop].time_wise_requirement) {
						// console.log(payload.data[prop].time_wise_requirement[prop1]);
						payload.data[prop].time_wise_requirement[prop1] =  parseFloat(payload.data[prop].time_wise_requirement[prop1]);
						delete payload.data[prop].activity_name;
						payload.data[prop]['timewise_data'] =  payload.data[prop].time_wise_requirement;
					}
					delete payload.data[prop].time_wise_requirement;
				}
				params = [...params, payload];
			}
			await this.bulkSaveNonCoverageHourlyData(params);
			await this.getNonCoverageActivitiesHourlyData();
			await this.getDailyActivitiesSummary();
		},
		updateValuesInRange(arrObj, startKey, endKey, changeValue, arrayElm) {
			 // Convert time to minutes since start of day
			 const toMinutes = time => {
				const [hours, minutes] = time.split('-').map(Number);
				return hours * 60 + minutes;
			};
		
			const startMinutes = toMinutes(startKey);
			const endMinutes = toMinutes(endKey);
		
			// Convert arrObj to an array of { time, value } objects
			let array = Object.entries(arrObj).map(([key, value]) => ({ time: key, value: value }));
		
			array.forEach((e) => {
				const currentMinutes = toMinutes(e.time);
		
				if (startMinutes === endMinutes) {
					// If start and end times are the same, just update those specific times
					if (currentMinutes === startMinutes) {
						e.value = changeValue;
						arrObj[e.time] = changeValue;
						console.log('Value getting updated', e);
					}
				} else if (startMinutes < endMinutes) {
					// Normal range within the same day
					if (currentMinutes >= startMinutes && currentMinutes < endMinutes) {
						e.value = changeValue;
						arrObj[e.time] = changeValue;
						console.log('Value getting updated', e);
					}
				} else {
					// Range spans across midnight
					if (currentMinutes >= startMinutes || currentMinutes < endMinutes) {
						e.value = changeValue;
						arrObj[e.time] = changeValue;
						console.log('Value getting updated', e);
					}
				}
			});
		
			return arrObj;
		},
		disableTimeElementForHourlyViewBulkEditEndTimeDropDown(time) {
			let result =  true;
			if(this.selected_hourly_view_start_time) {
				let startTimeIndex = this.nonCoverageDailyViewLabels.findIndex(el => el.label == this.selected_hourly_view_start_time);
				let timeIndex = this.nonCoverageDailyViewLabels.findIndex(el => el.label == time);
				if(timeIndex !== -1 && startTimeIndex !== -1) {
					if(timeIndex > startTimeIndex) {
						result = false;
					}
				}
			}
			return result;
		},
		async bulkSaveNonCoverageHourlyData(params) {
			await labourPlanningService.updateFixedActivitySummary(params).then(res => {
				this.$notify.success({
					title: "Success",
					message: "Successfully updated daily activities hourly data"
				});
			}).catch(error => console.error(error));
		},
		bulkUpdateNonCoverageHourlyData() {
			if (
				this.selected_hourly_activities_ids.length &&
				this.selected_hourly_view_start_time &&
				this.selected_hourly_view_end_time &&
				this.selected_hourly_view_days.length &&
				this.selected_hourly_view_number_of_people >= 0
			) {
				 // First we check selected days and filtered accordingly
				let selectedDaysData = this.selected_hourly_view_days.includes('all') ? this.non_coverage_activity_hourly_view : this.non_coverage_activity_hourly_view.filter((e) => this.selected_hourly_view_days.includes(e.day));
				// Now we can filter by activity
				for (let activityData of selectedDaysData) {
					for (const key in activityData.time_slot_and_function) {
						// Filter by activity here
						if(this.selected_hourly_activities_ids.includes(key)) {
							if (Object.hasOwnProperty.call(activityData.time_slot_and_function, key)) {
								let elm = activityData.time_slot_and_function[key];
								// Now need to add values according to time
								this.updateValuesInRange(elm.time_wise_requirement, this.selected_hourly_view_start_time, this.selected_hourly_view_end_time, parseFloat(this.selected_hourly_view_number_of_people), elm)
								// console.log(moment(this.selected_hourly_view_end_time, 'HH-mm').format('HH:mm:ss'), this.selected_hourly_view_number_of_people)
								// console.log(elm, key,this.selected_hourly_activities_ids, '++++++')
							}
						}
					}
				}
			}
			this.closeBulkEditHourlyModal();
		},
		closeBulkEditHourlyModal() {
			this.hide_show_bulk_edit_non_coverage_popup = false;
			this.selected_hourly_activities_ids = [];
			this.selected_hourly_view_start_time = '';
			this.selected_hourly_view_end_time = '';
			this.selected_hourly_view_days = [];
			this.selected_hourly_view_number_of_people = 0;
		},
		capitalizeFirstLetter(string) {
			return string.charAt(0).toUpperCase() + string.slice(1);
		},
		downloadBulkHourlyNonCoverageData() {
			labourPlanningService.exportFixedHours({store_id: this.outlet}).then(res => {
				const data = res.data;
				let storeName = this.getOutletName(this.outlet).replace(/ /g, '-');
				let date = new Date();
				date = moment(date).format('DD-MM-YYYY hh:mm:ss A');
				const fileName = `daily-activities-hourly-view-${storeName} - ${date}`;
				const blob = new Blob([data], { type: 'text/csv' });
				// Create a link element
				const link = document.createElement('a');
				link.href = window.URL.createObjectURL(blob);
				link.setAttribute('download', fileName);
				document.body.appendChild(link);
				link.click();
				document.body.removeChild(link);
			}
			).catch(error => console.error(error));
			
			return;
			let storeName = this.getOutletName(this.outlet).replace(/ /g, '-');
			let date = new Date();
			date = moment(date).format('DD-MM-YYYY hh:mm:ss A');
			const fileName = `daily-activities-hourly-view-${storeName} - ${date}`;
			let data = [];
			for(let i = 0; i < this.non_coverage_activity_hourly_view.length; i++) {
				let singleRow = this.non_coverage_activity_hourly_view[i];
				let dayLabel = this.capitalizeFirstLetter(singleRow.day);
				for(let prop in singleRow.time_slot_and_function) {
					let singleRowObj = {
						'Day': dayLabel,
					};
					singleRowObj['Activity'] = this.getActivityName(prop);
					let activityTimings = singleRow.time_slot_and_function[prop];
					for(let timeProp in activityTimings) {
						singleRowObj[this.getTimeLabel(timeProp)] = activityTimings[timeProp];
					}
					singleRowObj['Total'] = Object.values(activityTimings).map(el => el ? el : 0).reduce((partialSum, a) => parseInt(partialSum) + parseInt(a), 0);
					data.push(singleRowObj);
				}
			}
			const exportType = exportFromJSON.types.csv;
      exportFromJSON({ data, fileName, exportType });
		},
		getTimeLabel(timeValue) {
			let label = this.nonCoverageDailyViewLabels.find(el => el.label == timeValue);
			if(label !== undefined) {
				return label.value;
			} else {
				return 'X';
			}
		},
		filteredHourlyActivities(obj) {
			console.log(obj, 'filteredHourlyActivities')
			const predicate = (objKey) => !this.selected_hourly_filter_activities || !this.selected_hourly_filter_activities.length || this.selected_hourly_filter_activities.includes(objKey);
			Object.filter = (obj, predicate) => Object.keys(obj)
          .filter( key => predicate(key) )
          .reduce( (res, key) => Object.assign(res, { [key]: obj[key] }), {} );
			const result = Object.filter(obj, predicate);
			return result;
		},
		closeNonCoverageHourlyModal() {
			this.$confirm(
				"You might loose all your data if you haven't saved them yet. Do wish to close this window?",
				"Alert",
				{
					confirmButtonText: "Yes",
					cancelButtonText: "No",
					type: "warning",
					cancelButtonClass: "bg-success",
					confirmButtonClass: "bg-warning"
				}
			)
			.then(() => {
				this.hide_show_non_coverage_activity = false;
				this.non_coverage_activity_hourly_view = [];
				this.selected_hourly_filter_activities = [];
				this.selected_hourly_days = [];
			})
			.catch((_) => {});
		}
	},
	filters: {
		toTitleCase(str) {
			return str.replace(/\w\S*/g, function (txt) {
				return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
			});
		},
		timeFormat(time) {
			if (time) {
				return moment(time, "HH:mm:ss").format("hh:mm A");
			} else {
				return time;
			}
		},
		textUnderscoreToCapitalize(str) {
			if(str) {
				return str.replace(/_/g, ' ');
			} else {
				return str;
			}
		}
	},
};
